/* eslint-disable */

export const AllTypesProps: Record<string, any> = {
  AdminUpdateUserInput: {},
  Allocation: {},
  AllocationCsvInput: {},
  Allocations: {
    allocations: 'Allocation',
  },
  Boolean_comparison_exp: {},
  CreateCircleInput: {},
  CreateCircleResponse: {
    users: {
      distinct_on: 'users_select_column',
      order_by: 'users_order_by',
      where: 'users_bool_exp',
    },
  },
  CreateEpochInput: {
    start_date: 'timestamptz',
  },
  CreateNomineeInput: {},
  CreateUserInput: {},
  CreateUsersInput: {
    users: 'UserObj',
  },
  CreateVaultInput: {},
  DeleteEpochInput: {},
  DeleteUserInput: {},
  Int_comparison_exp: {},
  String_comparison_exp: {},
  UpdateCircleInput: {},
  UpdateEpochInput: {
    start_date: 'timestamptz',
  },
  UpdateTeammatesInput: {},
  UpdateUserInput: {},
  UploadCircleImageInput: {},
  UploadImageInput: {},
  UploadOrgImageInput: {},
  UserObj: {},
  VouchInput: {},
  bigint: 'String',
  bigint_comparison_exp: {
    _eq: 'bigint',
    _gt: 'bigint',
    _gte: 'bigint',
    _in: 'bigint',
    _lt: 'bigint',
    _lte: 'bigint',
    _neq: 'bigint',
    _nin: 'bigint',
  },
  burns_aggregate_order_by: {
    avg: 'burns_avg_order_by',
    count: 'order_by',
    max: 'burns_max_order_by',
    min: 'burns_min_order_by',
    stddev: 'burns_stddev_order_by',
    stddev_pop: 'burns_stddev_pop_order_by',
    stddev_samp: 'burns_stddev_samp_order_by',
    sum: 'burns_sum_order_by',
    var_pop: 'burns_var_pop_order_by',
    var_samp: 'burns_var_samp_order_by',
    variance: 'burns_variance_order_by',
  },
  burns_avg_order_by: {
    circle_id: 'order_by',
    epoch_id: 'order_by',
    id: 'order_by',
    original_amount: 'order_by',
    regift_percent: 'order_by',
    tokens_burnt: 'order_by',
    user_id: 'order_by',
  },
  burns_bool_exp: {
    _and: 'burns_bool_exp',
    _not: 'burns_bool_exp',
    _or: 'burns_bool_exp',
    circle: 'circles_bool_exp',
    circle_id: 'bigint_comparison_exp',
    created_at: 'timestamp_comparison_exp',
    epoch: 'epochs_bool_exp',
    epoch_id: 'bigint_comparison_exp',
    id: 'bigint_comparison_exp',
    original_amount: 'Int_comparison_exp',
    regift_percent: 'Int_comparison_exp',
    tokens_burnt: 'Int_comparison_exp',
    updated_at: 'timestamp_comparison_exp',
    user: 'users_bool_exp',
    user_id: 'bigint_comparison_exp',
  },
  burns_max_order_by: {
    circle_id: 'order_by',
    created_at: 'order_by',
    epoch_id: 'order_by',
    id: 'order_by',
    original_amount: 'order_by',
    regift_percent: 'order_by',
    tokens_burnt: 'order_by',
    updated_at: 'order_by',
    user_id: 'order_by',
  },
  burns_min_order_by: {
    circle_id: 'order_by',
    created_at: 'order_by',
    epoch_id: 'order_by',
    id: 'order_by',
    original_amount: 'order_by',
    regift_percent: 'order_by',
    tokens_burnt: 'order_by',
    updated_at: 'order_by',
    user_id: 'order_by',
  },
  burns_order_by: {
    circle: 'circles_order_by',
    circle_id: 'order_by',
    created_at: 'order_by',
    epoch: 'epochs_order_by',
    epoch_id: 'order_by',
    id: 'order_by',
    original_amount: 'order_by',
    regift_percent: 'order_by',
    tokens_burnt: 'order_by',
    updated_at: 'order_by',
    user: 'users_order_by',
    user_id: 'order_by',
  },
  burns_select_column: true,
  burns_stddev_order_by: {
    circle_id: 'order_by',
    epoch_id: 'order_by',
    id: 'order_by',
    original_amount: 'order_by',
    regift_percent: 'order_by',
    tokens_burnt: 'order_by',
    user_id: 'order_by',
  },
  burns_stddev_pop_order_by: {
    circle_id: 'order_by',
    epoch_id: 'order_by',
    id: 'order_by',
    original_amount: 'order_by',
    regift_percent: 'order_by',
    tokens_burnt: 'order_by',
    user_id: 'order_by',
  },
  burns_stddev_samp_order_by: {
    circle_id: 'order_by',
    epoch_id: 'order_by',
    id: 'order_by',
    original_amount: 'order_by',
    regift_percent: 'order_by',
    tokens_burnt: 'order_by',
    user_id: 'order_by',
  },
  burns_sum_order_by: {
    circle_id: 'order_by',
    epoch_id: 'order_by',
    id: 'order_by',
    original_amount: 'order_by',
    regift_percent: 'order_by',
    tokens_burnt: 'order_by',
    user_id: 'order_by',
  },
  burns_var_pop_order_by: {
    circle_id: 'order_by',
    epoch_id: 'order_by',
    id: 'order_by',
    original_amount: 'order_by',
    regift_percent: 'order_by',
    tokens_burnt: 'order_by',
    user_id: 'order_by',
  },
  burns_var_samp_order_by: {
    circle_id: 'order_by',
    epoch_id: 'order_by',
    id: 'order_by',
    original_amount: 'order_by',
    regift_percent: 'order_by',
    tokens_burnt: 'order_by',
    user_id: 'order_by',
  },
  burns_variance_order_by: {
    circle_id: 'order_by',
    epoch_id: 'order_by',
    id: 'order_by',
    original_amount: 'order_by',
    regift_percent: 'order_by',
    tokens_burnt: 'order_by',
    user_id: 'order_by',
  },
  circle_api_keys_aggregate_order_by: {
    avg: 'circle_api_keys_avg_order_by',
    count: 'order_by',
    max: 'circle_api_keys_max_order_by',
    min: 'circle_api_keys_min_order_by',
    stddev: 'circle_api_keys_stddev_order_by',
    stddev_pop: 'circle_api_keys_stddev_pop_order_by',
    stddev_samp: 'circle_api_keys_stddev_samp_order_by',
    sum: 'circle_api_keys_sum_order_by',
    var_pop: 'circle_api_keys_var_pop_order_by',
    var_samp: 'circle_api_keys_var_samp_order_by',
    variance: 'circle_api_keys_variance_order_by',
  },
  circle_api_keys_avg_order_by: {
    circle_id: 'order_by',
    created_by: 'order_by',
  },
  circle_api_keys_bool_exp: {
    _and: 'circle_api_keys_bool_exp',
    _not: 'circle_api_keys_bool_exp',
    _or: 'circle_api_keys_bool_exp',
    circle: 'circles_bool_exp',
    circle_id: 'bigint_comparison_exp',
    create_vouches: 'Boolean_comparison_exp',
    createdByUser: 'users_bool_exp',
    created_at: 'timestamptz_comparison_exp',
    created_by: 'bigint_comparison_exp',
    hash: 'String_comparison_exp',
    name: 'String_comparison_exp',
    read_circle: 'Boolean_comparison_exp',
    read_epochs: 'Boolean_comparison_exp',
    read_member_profiles: 'Boolean_comparison_exp',
    read_nominees: 'Boolean_comparison_exp',
    read_pending_token_gifts: 'Boolean_comparison_exp',
    update_circle: 'Boolean_comparison_exp',
    update_pending_token_gifts: 'Boolean_comparison_exp',
  },
  circle_api_keys_max_order_by: {
    circle_id: 'order_by',
    created_at: 'order_by',
    created_by: 'order_by',
    hash: 'order_by',
    name: 'order_by',
  },
  circle_api_keys_min_order_by: {
    circle_id: 'order_by',
    created_at: 'order_by',
    created_by: 'order_by',
    hash: 'order_by',
    name: 'order_by',
  },
  circle_api_keys_order_by: {
    circle: 'circles_order_by',
    circle_id: 'order_by',
    create_vouches: 'order_by',
    createdByUser: 'users_order_by',
    created_at: 'order_by',
    created_by: 'order_by',
    hash: 'order_by',
    name: 'order_by',
    read_circle: 'order_by',
    read_epochs: 'order_by',
    read_member_profiles: 'order_by',
    read_nominees: 'order_by',
    read_pending_token_gifts: 'order_by',
    update_circle: 'order_by',
    update_pending_token_gifts: 'order_by',
  },
  circle_api_keys_select_column: true,
  circle_api_keys_stddev_order_by: {
    circle_id: 'order_by',
    created_by: 'order_by',
  },
  circle_api_keys_stddev_pop_order_by: {
    circle_id: 'order_by',
    created_by: 'order_by',
  },
  circle_api_keys_stddev_samp_order_by: {
    circle_id: 'order_by',
    created_by: 'order_by',
  },
  circle_api_keys_sum_order_by: {
    circle_id: 'order_by',
    created_by: 'order_by',
  },
  circle_api_keys_var_pop_order_by: {
    circle_id: 'order_by',
    created_by: 'order_by',
  },
  circle_api_keys_var_samp_order_by: {
    circle_id: 'order_by',
    created_by: 'order_by',
  },
  circle_api_keys_variance_order_by: {
    circle_id: 'order_by',
    created_by: 'order_by',
  },
  circle_integrations: {
    data: {},
  },
  circle_integrations_aggregate_order_by: {
    avg: 'circle_integrations_avg_order_by',
    count: 'order_by',
    max: 'circle_integrations_max_order_by',
    min: 'circle_integrations_min_order_by',
    stddev: 'circle_integrations_stddev_order_by',
    stddev_pop: 'circle_integrations_stddev_pop_order_by',
    stddev_samp: 'circle_integrations_stddev_samp_order_by',
    sum: 'circle_integrations_sum_order_by',
    var_pop: 'circle_integrations_var_pop_order_by',
    var_samp: 'circle_integrations_var_samp_order_by',
    variance: 'circle_integrations_variance_order_by',
  },
  circle_integrations_avg_order_by: {
    circle_id: 'order_by',
    id: 'order_by',
  },
  circle_integrations_bool_exp: {
    _and: 'circle_integrations_bool_exp',
    _not: 'circle_integrations_bool_exp',
    _or: 'circle_integrations_bool_exp',
    circle: 'circles_bool_exp',
    circle_id: 'bigint_comparison_exp',
    data: 'json_comparison_exp',
    id: 'bigint_comparison_exp',
    name: 'String_comparison_exp',
    type: 'String_comparison_exp',
  },
  circle_integrations_insert_input: {
    circle_id: 'bigint',
    data: 'json',
  },
  circle_integrations_max_order_by: {
    circle_id: 'order_by',
    id: 'order_by',
    name: 'order_by',
    type: 'order_by',
  },
  circle_integrations_min_order_by: {
    circle_id: 'order_by',
    id: 'order_by',
    name: 'order_by',
    type: 'order_by',
  },
  circle_integrations_order_by: {
    circle: 'circles_order_by',
    circle_id: 'order_by',
    data: 'order_by',
    id: 'order_by',
    name: 'order_by',
    type: 'order_by',
  },
  circle_integrations_select_column: true,
  circle_integrations_stddev_order_by: {
    circle_id: 'order_by',
    id: 'order_by',
  },
  circle_integrations_stddev_pop_order_by: {
    circle_id: 'order_by',
    id: 'order_by',
  },
  circle_integrations_stddev_samp_order_by: {
    circle_id: 'order_by',
    id: 'order_by',
  },
  circle_integrations_sum_order_by: {
    circle_id: 'order_by',
    id: 'order_by',
  },
  circle_integrations_var_pop_order_by: {
    circle_id: 'order_by',
    id: 'order_by',
  },
  circle_integrations_var_samp_order_by: {
    circle_id: 'order_by',
    id: 'order_by',
  },
  circle_integrations_variance_order_by: {
    circle_id: 'order_by',
    id: 'order_by',
  },
  circle_private_bool_exp: {
    _and: 'circle_private_bool_exp',
    _not: 'circle_private_bool_exp',
    _or: 'circle_private_bool_exp',
    circle: 'circles_bool_exp',
    circle_id: 'bigint_comparison_exp',
    discord_webhook: 'String_comparison_exp',
  },
  circle_private_order_by: {
    circle: 'circles_order_by',
    circle_id: 'order_by',
    discord_webhook: 'order_by',
  },
  circle_private_select_column: true,
  circles: {
    api_keys: {
      distinct_on: 'circle_api_keys_select_column',
      order_by: 'circle_api_keys_order_by',
      where: 'circle_api_keys_bool_exp',
    },
    burns: {
      distinct_on: 'burns_select_column',
      order_by: 'burns_order_by',
      where: 'burns_bool_exp',
    },
    epochs: {
      distinct_on: 'epochs_select_column',
      order_by: 'epochs_order_by',
      where: 'epochs_bool_exp',
    },
    integrations: {
      distinct_on: 'circle_integrations_select_column',
      order_by: 'circle_integrations_order_by',
      where: 'circle_integrations_bool_exp',
    },
    nominees: {
      distinct_on: 'nominees_select_column',
      order_by: 'nominees_order_by',
      where: 'nominees_bool_exp',
    },
    nominees_aggregate: {
      distinct_on: 'nominees_select_column',
      order_by: 'nominees_order_by',
      where: 'nominees_bool_exp',
    },
    pending_token_gifts: {
      distinct_on: 'pending_token_gifts_select_column',
      order_by: 'pending_token_gifts_order_by',
      where: 'pending_token_gifts_bool_exp',
    },
    token_gifts: {
      distinct_on: 'token_gifts_select_column',
      order_by: 'token_gifts_order_by',
      where: 'token_gifts_bool_exp',
    },
    token_gifts_aggregate: {
      distinct_on: 'token_gifts_select_column',
      order_by: 'token_gifts_order_by',
      where: 'token_gifts_bool_exp',
    },
    users: {
      distinct_on: 'users_select_column',
      order_by: 'users_order_by',
      where: 'users_bool_exp',
    },
  },
  circles_aggregate_order_by: {
    avg: 'circles_avg_order_by',
    count: 'order_by',
    max: 'circles_max_order_by',
    min: 'circles_min_order_by',
    stddev: 'circles_stddev_order_by',
    stddev_pop: 'circles_stddev_pop_order_by',
    stddev_samp: 'circles_stddev_samp_order_by',
    sum: 'circles_sum_order_by',
    var_pop: 'circles_var_pop_order_by',
    var_samp: 'circles_var_samp_order_by',
    variance: 'circles_variance_order_by',
  },
  circles_avg_order_by: {
    id: 'order_by',
    min_vouches: 'order_by',
    nomination_days_limit: 'order_by',
    protocol_id: 'order_by',
  },
  circles_bool_exp: {
    _and: 'circles_bool_exp',
    _not: 'circles_bool_exp',
    _or: 'circles_bool_exp',
    alloc_text: 'String_comparison_exp',
    api_keys: 'circle_api_keys_bool_exp',
    auto_opt_out: 'Boolean_comparison_exp',
    burns: 'burns_bool_exp',
    circle_private: 'circle_private_bool_exp',
    created_at: 'timestamp_comparison_exp',
    default_opt_in: 'Boolean_comparison_exp',
    epochs: 'epochs_bool_exp',
    fixed_payment_token_type: 'String_comparison_exp',
    id: 'bigint_comparison_exp',
    integrations: 'circle_integrations_bool_exp',
    is_verified: 'Boolean_comparison_exp',
    logo: 'String_comparison_exp',
    min_vouches: 'Int_comparison_exp',
    name: 'String_comparison_exp',
    nomination_days_limit: 'Int_comparison_exp',
    nominees: 'nominees_bool_exp',
    only_giver_vouch: 'Boolean_comparison_exp',
    organization: 'organizations_bool_exp',
    pending_token_gifts: 'pending_token_gifts_bool_exp',
    protocol_id: 'Int_comparison_exp',
    team_sel_text: 'String_comparison_exp',
    team_selection: 'Boolean_comparison_exp',
    token_gifts: 'token_gifts_bool_exp',
    token_name: 'String_comparison_exp',
    updated_at: 'timestamp_comparison_exp',
    users: 'users_bool_exp',
    vouching: 'Boolean_comparison_exp',
    vouching_text: 'String_comparison_exp',
  },
  circles_inc_input: {},
  circles_max_order_by: {
    alloc_text: 'order_by',
    created_at: 'order_by',
    fixed_payment_token_type: 'order_by',
    id: 'order_by',
    logo: 'order_by',
    min_vouches: 'order_by',
    name: 'order_by',
    nomination_days_limit: 'order_by',
    protocol_id: 'order_by',
    team_sel_text: 'order_by',
    token_name: 'order_by',
    updated_at: 'order_by',
    vouching_text: 'order_by',
  },
  circles_min_order_by: {
    alloc_text: 'order_by',
    created_at: 'order_by',
    fixed_payment_token_type: 'order_by',
    id: 'order_by',
    logo: 'order_by',
    min_vouches: 'order_by',
    name: 'order_by',
    nomination_days_limit: 'order_by',
    protocol_id: 'order_by',
    team_sel_text: 'order_by',
    token_name: 'order_by',
    updated_at: 'order_by',
    vouching_text: 'order_by',
  },
  circles_order_by: {
    alloc_text: 'order_by',
    api_keys_aggregate: 'circle_api_keys_aggregate_order_by',
    auto_opt_out: 'order_by',
    burns_aggregate: 'burns_aggregate_order_by',
    circle_private: 'circle_private_order_by',
    created_at: 'order_by',
    default_opt_in: 'order_by',
    epochs_aggregate: 'epochs_aggregate_order_by',
    fixed_payment_token_type: 'order_by',
    id: 'order_by',
    integrations_aggregate: 'circle_integrations_aggregate_order_by',
    is_verified: 'order_by',
    logo: 'order_by',
    min_vouches: 'order_by',
    name: 'order_by',
    nomination_days_limit: 'order_by',
    nominees_aggregate: 'nominees_aggregate_order_by',
    only_giver_vouch: 'order_by',
    organization: 'organizations_order_by',
    pending_token_gifts_aggregate: 'pending_token_gifts_aggregate_order_by',
    protocol_id: 'order_by',
    team_sel_text: 'order_by',
    team_selection: 'order_by',
    token_gifts_aggregate: 'token_gifts_aggregate_order_by',
    token_name: 'order_by',
    updated_at: 'order_by',
    users_aggregate: 'users_aggregate_order_by',
    vouching: 'order_by',
    vouching_text: 'order_by',
  },
  circles_pk_columns_input: {
    id: 'bigint',
  },
  circles_select_column: true,
  circles_set_input: {},
  circles_stddev_order_by: {
    id: 'order_by',
    min_vouches: 'order_by',
    nomination_days_limit: 'order_by',
    protocol_id: 'order_by',
  },
  circles_stddev_pop_order_by: {
    id: 'order_by',
    min_vouches: 'order_by',
    nomination_days_limit: 'order_by',
    protocol_id: 'order_by',
  },
  circles_stddev_samp_order_by: {
    id: 'order_by',
    min_vouches: 'order_by',
    nomination_days_limit: 'order_by',
    protocol_id: 'order_by',
  },
  circles_sum_order_by: {
    id: 'order_by',
    min_vouches: 'order_by',
    nomination_days_limit: 'order_by',
    protocol_id: 'order_by',
  },
  circles_var_pop_order_by: {
    id: 'order_by',
    min_vouches: 'order_by',
    nomination_days_limit: 'order_by',
    protocol_id: 'order_by',
  },
  circles_var_samp_order_by: {
    id: 'order_by',
    min_vouches: 'order_by',
    nomination_days_limit: 'order_by',
    protocol_id: 'order_by',
  },
  circles_variance_order_by: {
    id: 'order_by',
    min_vouches: 'order_by',
    nomination_days_limit: 'order_by',
    protocol_id: 'order_by',
  },
  claims_aggregate_order_by: {
    avg: 'claims_avg_order_by',
    count: 'order_by',
    max: 'claims_max_order_by',
    min: 'claims_min_order_by',
    stddev: 'claims_stddev_order_by',
    stddev_pop: 'claims_stddev_pop_order_by',
    stddev_samp: 'claims_stddev_samp_order_by',
    sum: 'claims_sum_order_by',
    var_pop: 'claims_var_pop_order_by',
    var_samp: 'claims_var_samp_order_by',
    variance: 'claims_variance_order_by',
  },
  claims_arr_rel_insert_input: {
    data: 'claims_insert_input',
    on_conflict: 'claims_on_conflict',
  },
  claims_avg_order_by: {
    amount: 'order_by',
    distribution_id: 'order_by',
    id: 'order_by',
    index: 'order_by',
    new_amount: 'order_by',
    user_id: 'order_by',
  },
  claims_bool_exp: {
    _and: 'claims_bool_exp',
    _not: 'claims_bool_exp',
    _or: 'claims_bool_exp',
    address: 'String_comparison_exp',
    amount: 'numeric_comparison_exp',
    claimed: 'Boolean_comparison_exp',
    created_at: 'timestamptz_comparison_exp',
    distribution: 'distributions_bool_exp',
    distribution_id: 'bigint_comparison_exp',
    id: 'bigint_comparison_exp',
    index: 'bigint_comparison_exp',
    new_amount: 'numeric_comparison_exp',
    proof: 'String_comparison_exp',
    updated_at: 'timestamptz_comparison_exp',
    user: 'users_bool_exp',
    user_id: 'bigint_comparison_exp',
  },
  claims_constraint: true,
  claims_insert_input: {
    amount: 'numeric',
    distribution: 'distributions_obj_rel_insert_input',
    id: 'bigint',
    index: 'bigint',
    new_amount: 'numeric',
    user_id: 'bigint',
  },
  claims_max_order_by: {
    address: 'order_by',
    amount: 'order_by',
    created_at: 'order_by',
    distribution_id: 'order_by',
    id: 'order_by',
    index: 'order_by',
    new_amount: 'order_by',
    proof: 'order_by',
    updated_at: 'order_by',
    user_id: 'order_by',
  },
  claims_min_order_by: {
    address: 'order_by',
    amount: 'order_by',
    created_at: 'order_by',
    distribution_id: 'order_by',
    id: 'order_by',
    index: 'order_by',
    new_amount: 'order_by',
    proof: 'order_by',
    updated_at: 'order_by',
    user_id: 'order_by',
  },
  claims_on_conflict: {
    constraint: 'claims_constraint',
    update_columns: 'claims_update_column',
    where: 'claims_bool_exp',
  },
  claims_order_by: {
    address: 'order_by',
    amount: 'order_by',
    claimed: 'order_by',
    created_at: 'order_by',
    distribution: 'distributions_order_by',
    distribution_id: 'order_by',
    id: 'order_by',
    index: 'order_by',
    new_amount: 'order_by',
    proof: 'order_by',
    updated_at: 'order_by',
    user: 'users_order_by',
    user_id: 'order_by',
  },
  claims_pk_columns_input: {
    id: 'bigint',
  },
  claims_select_column: true,
  claims_set_input: {},
  claims_stddev_order_by: {
    amount: 'order_by',
    distribution_id: 'order_by',
    id: 'order_by',
    index: 'order_by',
    new_amount: 'order_by',
    user_id: 'order_by',
  },
  claims_stddev_pop_order_by: {
    amount: 'order_by',
    distribution_id: 'order_by',
    id: 'order_by',
    index: 'order_by',
    new_amount: 'order_by',
    user_id: 'order_by',
  },
  claims_stddev_samp_order_by: {
    amount: 'order_by',
    distribution_id: 'order_by',
    id: 'order_by',
    index: 'order_by',
    new_amount: 'order_by',
    user_id: 'order_by',
  },
  claims_sum_order_by: {
    amount: 'order_by',
    distribution_id: 'order_by',
    id: 'order_by',
    index: 'order_by',
    new_amount: 'order_by',
    user_id: 'order_by',
  },
  claims_update_column: true,
  claims_var_pop_order_by: {
    amount: 'order_by',
    distribution_id: 'order_by',
    id: 'order_by',
    index: 'order_by',
    new_amount: 'order_by',
    user_id: 'order_by',
  },
  claims_var_samp_order_by: {
    amount: 'order_by',
    distribution_id: 'order_by',
    id: 'order_by',
    index: 'order_by',
    new_amount: 'order_by',
    user_id: 'order_by',
  },
  claims_variance_order_by: {
    amount: 'order_by',
    distribution_id: 'order_by',
    id: 'order_by',
    index: 'order_by',
    new_amount: 'order_by',
    user_id: 'order_by',
  },
  date: 'String',
  date_comparison_exp: {
    _eq: 'date',
    _gt: 'date',
    _gte: 'date',
    _in: 'date',
    _lt: 'date',
    _lte: 'date',
    _neq: 'date',
    _nin: 'date',
  },
  distributions: {
    claims: {
      distinct_on: 'claims_select_column',
      order_by: 'claims_order_by',
      where: 'claims_bool_exp',
    },
    distribution_json: {},
  },
  distributions_aggregate_fields: {
    count: {
      columns: 'distributions_select_column',
    },
  },
  distributions_aggregate_order_by: {
    avg: 'distributions_avg_order_by',
    count: 'order_by',
    max: 'distributions_max_order_by',
    min: 'distributions_min_order_by',
    stddev: 'distributions_stddev_order_by',
    stddev_pop: 'distributions_stddev_pop_order_by',
    stddev_samp: 'distributions_stddev_samp_order_by',
    sum: 'distributions_sum_order_by',
    var_pop: 'distributions_var_pop_order_by',
    var_samp: 'distributions_var_samp_order_by',
    variance: 'distributions_variance_order_by',
  },
  distributions_avg_order_by: {
    created_by: 'order_by',
    distribution_epoch_id: 'order_by',
    epoch_id: 'order_by',
    id: 'order_by',
    total_amount: 'order_by',
    vault_id: 'order_by',
  },
  distributions_bool_exp: {
    _and: 'distributions_bool_exp',
    _not: 'distributions_bool_exp',
    _or: 'distributions_bool_exp',
    claims: 'claims_bool_exp',
    created_at: 'timestamp_comparison_exp',
    created_by: 'bigint_comparison_exp',
    distribution_epoch_id: 'bigint_comparison_exp',
    distribution_json: 'jsonb_comparison_exp',
    epoch: 'epochs_bool_exp',
    epoch_id: 'bigint_comparison_exp',
    id: 'bigint_comparison_exp',
    merkle_root: 'String_comparison_exp',
    total_amount: 'numeric_comparison_exp',
    tx_hash: 'String_comparison_exp',
    vault: 'vaults_bool_exp',
    vault_id: 'bigint_comparison_exp',
  },
  distributions_constraint: true,
  distributions_inc_input: {
    distribution_epoch_id: 'bigint',
  },
  distributions_insert_input: {
    claims: 'claims_arr_rel_insert_input',
    distribution_epoch_id: 'bigint',
    distribution_json: 'jsonb',
    epoch_id: 'bigint',
    total_amount: 'numeric',
    vault_id: 'bigint',
  },
  distributions_max_order_by: {
    created_at: 'order_by',
    created_by: 'order_by',
    distribution_epoch_id: 'order_by',
    epoch_id: 'order_by',
    id: 'order_by',
    merkle_root: 'order_by',
    total_amount: 'order_by',
    tx_hash: 'order_by',
    vault_id: 'order_by',
  },
  distributions_min_order_by: {
    created_at: 'order_by',
    created_by: 'order_by',
    distribution_epoch_id: 'order_by',
    epoch_id: 'order_by',
    id: 'order_by',
    merkle_root: 'order_by',
    total_amount: 'order_by',
    tx_hash: 'order_by',
    vault_id: 'order_by',
  },
  distributions_obj_rel_insert_input: {
    data: 'distributions_insert_input',
    on_conflict: 'distributions_on_conflict',
  },
  distributions_on_conflict: {
    constraint: 'distributions_constraint',
    update_columns: 'distributions_update_column',
    where: 'distributions_bool_exp',
  },
  distributions_order_by: {
    claims_aggregate: 'claims_aggregate_order_by',
    created_at: 'order_by',
    created_by: 'order_by',
    distribution_epoch_id: 'order_by',
    distribution_json: 'order_by',
    epoch: 'epochs_order_by',
    epoch_id: 'order_by',
    id: 'order_by',
    merkle_root: 'order_by',
    total_amount: 'order_by',
    tx_hash: 'order_by',
    vault: 'vaults_order_by',
    vault_id: 'order_by',
  },
  distributions_pk_columns_input: {
    id: 'bigint',
  },
  distributions_select_column: true,
  distributions_set_input: {
    distribution_epoch_id: 'bigint',
  },
  distributions_stddev_order_by: {
    created_by: 'order_by',
    distribution_epoch_id: 'order_by',
    epoch_id: 'order_by',
    id: 'order_by',
    total_amount: 'order_by',
    vault_id: 'order_by',
  },
  distributions_stddev_pop_order_by: {
    created_by: 'order_by',
    distribution_epoch_id: 'order_by',
    epoch_id: 'order_by',
    id: 'order_by',
    total_amount: 'order_by',
    vault_id: 'order_by',
  },
  distributions_stddev_samp_order_by: {
    created_by: 'order_by',
    distribution_epoch_id: 'order_by',
    epoch_id: 'order_by',
    id: 'order_by',
    total_amount: 'order_by',
    vault_id: 'order_by',
  },
  distributions_sum_order_by: {
    created_by: 'order_by',
    distribution_epoch_id: 'order_by',
    epoch_id: 'order_by',
    id: 'order_by',
    total_amount: 'order_by',
    vault_id: 'order_by',
  },
  distributions_update_column: true,
  distributions_var_pop_order_by: {
    created_by: 'order_by',
    distribution_epoch_id: 'order_by',
    epoch_id: 'order_by',
    id: 'order_by',
    total_amount: 'order_by',
    vault_id: 'order_by',
  },
  distributions_var_samp_order_by: {
    created_by: 'order_by',
    distribution_epoch_id: 'order_by',
    epoch_id: 'order_by',
    id: 'order_by',
    total_amount: 'order_by',
    vault_id: 'order_by',
  },
  distributions_variance_order_by: {
    created_by: 'order_by',
    distribution_epoch_id: 'order_by',
    epoch_id: 'order_by',
    id: 'order_by',
    total_amount: 'order_by',
    vault_id: 'order_by',
  },
  epochs: {
    burns: {
      distinct_on: 'burns_select_column',
      order_by: 'burns_order_by',
      where: 'burns_bool_exp',
    },
    distributions: {
      distinct_on: 'distributions_select_column',
      order_by: 'distributions_order_by',
      where: 'distributions_bool_exp',
    },
    distributions_aggregate: {
      distinct_on: 'distributions_select_column',
      order_by: 'distributions_order_by',
      where: 'distributions_bool_exp',
    },
    epoch_pending_token_gifts: {
      distinct_on: 'pending_token_gifts_select_column',
      order_by: 'pending_token_gifts_order_by',
      where: 'pending_token_gifts_bool_exp',
    },
    token_gifts: {
      distinct_on: 'token_gifts_select_column',
      order_by: 'token_gifts_order_by',
      where: 'token_gifts_bool_exp',
    },
    token_gifts_aggregate: {
      distinct_on: 'token_gifts_select_column',
      order_by: 'token_gifts_order_by',
      where: 'token_gifts_bool_exp',
    },
  },
  epochs_aggregate_order_by: {
    avg: 'epochs_avg_order_by',
    count: 'order_by',
    max: 'epochs_max_order_by',
    min: 'epochs_min_order_by',
    stddev: 'epochs_stddev_order_by',
    stddev_pop: 'epochs_stddev_pop_order_by',
    stddev_samp: 'epochs_stddev_samp_order_by',
    sum: 'epochs_sum_order_by',
    var_pop: 'epochs_var_pop_order_by',
    var_samp: 'epochs_var_samp_order_by',
    variance: 'epochs_variance_order_by',
  },
  epochs_avg_order_by: {
    circle_id: 'order_by',
    days: 'order_by',
    grant: 'order_by',
    id: 'order_by',
    number: 'order_by',
    repeat: 'order_by',
    repeat_day_of_month: 'order_by',
  },
  epochs_bool_exp: {
    _and: 'epochs_bool_exp',
    _not: 'epochs_bool_exp',
    _or: 'epochs_bool_exp',
    burns: 'burns_bool_exp',
    circle: 'circles_bool_exp',
    circle_id: 'Int_comparison_exp',
    created_at: 'timestamp_comparison_exp',
    days: 'Int_comparison_exp',
    distributions: 'distributions_bool_exp',
    end_date: 'timestamptz_comparison_exp',
    ended: 'Boolean_comparison_exp',
    epoch_pending_token_gifts: 'pending_token_gifts_bool_exp',
    grant: 'numeric_comparison_exp',
    id: 'bigint_comparison_exp',
    notified_before_end: 'timestamp_comparison_exp',
    notified_end: 'timestamp_comparison_exp',
    notified_start: 'timestamp_comparison_exp',
    number: 'Int_comparison_exp',
    repeat: 'Int_comparison_exp',
    repeat_day_of_month: 'Int_comparison_exp',
    start_date: 'timestamptz_comparison_exp',
    token_gifts: 'token_gifts_bool_exp',
    updated_at: 'timestamp_comparison_exp',
  },
  epochs_max_order_by: {
    circle_id: 'order_by',
    created_at: 'order_by',
    days: 'order_by',
    end_date: 'order_by',
    grant: 'order_by',
    id: 'order_by',
    notified_before_end: 'order_by',
    notified_end: 'order_by',
    notified_start: 'order_by',
    number: 'order_by',
    repeat: 'order_by',
    repeat_day_of_month: 'order_by',
    start_date: 'order_by',
    updated_at: 'order_by',
  },
  epochs_min_order_by: {
    circle_id: 'order_by',
    created_at: 'order_by',
    days: 'order_by',
    end_date: 'order_by',
    grant: 'order_by',
    id: 'order_by',
    notified_before_end: 'order_by',
    notified_end: 'order_by',
    notified_start: 'order_by',
    number: 'order_by',
    repeat: 'order_by',
    repeat_day_of_month: 'order_by',
    start_date: 'order_by',
    updated_at: 'order_by',
  },
  epochs_order_by: {
    burns_aggregate: 'burns_aggregate_order_by',
    circle: 'circles_order_by',
    circle_id: 'order_by',
    created_at: 'order_by',
    days: 'order_by',
    distributions_aggregate: 'distributions_aggregate_order_by',
    end_date: 'order_by',
    ended: 'order_by',
    epoch_pending_token_gifts_aggregate:
      'pending_token_gifts_aggregate_order_by',
    grant: 'order_by',
    id: 'order_by',
    notified_before_end: 'order_by',
    notified_end: 'order_by',
    notified_start: 'order_by',
    number: 'order_by',
    repeat: 'order_by',
    repeat_day_of_month: 'order_by',
    start_date: 'order_by',
    token_gifts_aggregate: 'token_gifts_aggregate_order_by',
    updated_at: 'order_by',
  },
  epochs_select_column: true,
  epochs_stddev_order_by: {
    circle_id: 'order_by',
    days: 'order_by',
    grant: 'order_by',
    id: 'order_by',
    number: 'order_by',
    repeat: 'order_by',
    repeat_day_of_month: 'order_by',
  },
  epochs_stddev_pop_order_by: {
    circle_id: 'order_by',
    days: 'order_by',
    grant: 'order_by',
    id: 'order_by',
    number: 'order_by',
    repeat: 'order_by',
    repeat_day_of_month: 'order_by',
  },
  epochs_stddev_samp_order_by: {
    circle_id: 'order_by',
    days: 'order_by',
    grant: 'order_by',
    id: 'order_by',
    number: 'order_by',
    repeat: 'order_by',
    repeat_day_of_month: 'order_by',
  },
  epochs_sum_order_by: {
    circle_id: 'order_by',
    days: 'order_by',
    grant: 'order_by',
    id: 'order_by',
    number: 'order_by',
    repeat: 'order_by',
    repeat_day_of_month: 'order_by',
  },
  epochs_var_pop_order_by: {
    circle_id: 'order_by',
    days: 'order_by',
    grant: 'order_by',
    id: 'order_by',
    number: 'order_by',
    repeat: 'order_by',
    repeat_day_of_month: 'order_by',
  },
  epochs_var_samp_order_by: {
    circle_id: 'order_by',
    days: 'order_by',
    grant: 'order_by',
    id: 'order_by',
    number: 'order_by',
    repeat: 'order_by',
    repeat_day_of_month: 'order_by',
  },
  epochs_variance_order_by: {
    circle_id: 'order_by',
    days: 'order_by',
    grant: 'order_by',
    id: 'order_by',
    number: 'order_by',
    repeat: 'order_by',
    repeat_day_of_month: 'order_by',
  },
  gift_private_bool_exp: {
    _and: 'gift_private_bool_exp',
    _not: 'gift_private_bool_exp',
    _or: 'gift_private_bool_exp',
    gift_id: 'bigint_comparison_exp',
    note: 'String_comparison_exp',
    recipient: 'users_bool_exp',
    recipient_id: 'bigint_comparison_exp',
    sender: 'users_bool_exp',
    sender_id: 'bigint_comparison_exp',
  },
  gift_private_order_by: {
    gift_id: 'order_by',
    note: 'order_by',
    recipient: 'users_order_by',
    recipient_id: 'order_by',
    sender: 'users_order_by',
    sender_id: 'order_by',
  },
  gift_private_select_column: true,
  json: 'String',
  json_comparison_exp: {
    _eq: 'json',
    _gt: 'json',
    _gte: 'json',
    _in: 'json',
    _lt: 'json',
    _lte: 'json',
    _neq: 'json',
    _nin: 'json',
  },
  jsonb: 'String',
  jsonb_comparison_exp: {
    _contained_in: 'jsonb',
    _contains: 'jsonb',
    _eq: 'jsonb',
    _gt: 'jsonb',
    _gte: 'jsonb',
    _in: 'jsonb',
    _lt: 'jsonb',
    _lte: 'jsonb',
    _neq: 'jsonb',
    _nin: 'jsonb',
  },
  mutation_root: {
    adminUpdateUser: {
      payload: 'AdminUpdateUserInput',
    },
    allocationCsv: {
      payload: 'AllocationCsvInput',
    },
    createCircle: {
      payload: 'CreateCircleInput',
    },
    createEpoch: {
      payload: 'CreateEpochInput',
    },
    createNominee: {
      payload: 'CreateNomineeInput',
    },
    createUser: {
      payload: 'CreateUserInput',
    },
    createUsers: {
      payload: 'CreateUsersInput',
    },
    createVault: {
      payload: 'CreateVaultInput',
    },
    deleteEpoch: {
      payload: 'DeleteEpochInput',
    },
    deleteUser: {
      payload: 'DeleteUserInput',
    },
    delete_circle_api_keys: {
      where: 'circle_api_keys_bool_exp',
    },
    delete_circle_api_keys_by_pk: {},
    delete_circle_integrations: {
      where: 'circle_integrations_bool_exp',
    },
    delete_circle_integrations_by_pk: {
      id: 'bigint',
    },
    insert_circle_integrations: {
      objects: 'circle_integrations_insert_input',
    },
    insert_circle_integrations_one: {
      object: 'circle_integrations_insert_input',
    },
    insert_claims: {
      objects: 'claims_insert_input',
      on_conflict: 'claims_on_conflict',
    },
    insert_claims_one: {
      object: 'claims_insert_input',
      on_conflict: 'claims_on_conflict',
    },
    insert_distributions: {
      objects: 'distributions_insert_input',
      on_conflict: 'distributions_on_conflict',
    },
    insert_distributions_one: {
      object: 'distributions_insert_input',
      on_conflict: 'distributions_on_conflict',
    },
    insert_vault_transactions: {
      objects: 'vault_transactions_insert_input',
    },
    insert_vault_transactions_one: {
      object: 'vault_transactions_insert_input',
    },
    updateAllocations: {
      payload: 'Allocations',
    },
    updateCircle: {
      payload: 'UpdateCircleInput',
    },
    updateEpoch: {
      payload: 'UpdateEpochInput',
    },
    updateTeammates: {
      payload: 'UpdateTeammatesInput',
    },
    updateUser: {
      payload: 'UpdateUserInput',
    },
    update_circles: {
      _inc: 'circles_inc_input',
      _set: 'circles_set_input',
      where: 'circles_bool_exp',
    },
    update_circles_by_pk: {
      _inc: 'circles_inc_input',
      _set: 'circles_set_input',
      pk_columns: 'circles_pk_columns_input',
    },
    update_claims: {
      _set: 'claims_set_input',
      where: 'claims_bool_exp',
    },
    update_claims_by_pk: {
      _set: 'claims_set_input',
      pk_columns: 'claims_pk_columns_input',
    },
    update_distributions: {
      _inc: 'distributions_inc_input',
      _set: 'distributions_set_input',
      where: 'distributions_bool_exp',
    },
    update_distributions_by_pk: {
      _inc: 'distributions_inc_input',
      _set: 'distributions_set_input',
      pk_columns: 'distributions_pk_columns_input',
    },
    update_profiles: {
      _set: 'profiles_set_input',
      where: 'profiles_bool_exp',
    },
    update_profiles_by_pk: {
      _set: 'profiles_set_input',
      pk_columns: 'profiles_pk_columns_input',
    },
    uploadCircleLogo: {
      payload: 'UploadCircleImageInput',
    },
    uploadOrgLogo: {
      payload: 'UploadOrgImageInput',
    },
    uploadProfileAvatar: {
      payload: 'UploadImageInput',
    },
    uploadProfileBackground: {
      payload: 'UploadImageInput',
    },
    vouch: {
      payload: 'VouchInput',
    },
  },
  nominees: {
    nominations: {
      distinct_on: 'vouches_select_column',
      order_by: 'vouches_order_by',
      where: 'vouches_bool_exp',
    },
  },
  nominees_aggregate_fields: {
    count: {
      columns: 'nominees_select_column',
    },
  },
  nominees_aggregate_order_by: {
    avg: 'nominees_avg_order_by',
    count: 'order_by',
    max: 'nominees_max_order_by',
    min: 'nominees_min_order_by',
    stddev: 'nominees_stddev_order_by',
    stddev_pop: 'nominees_stddev_pop_order_by',
    stddev_samp: 'nominees_stddev_samp_order_by',
    sum: 'nominees_sum_order_by',
    var_pop: 'nominees_var_pop_order_by',
    var_samp: 'nominees_var_samp_order_by',
    variance: 'nominees_variance_order_by',
  },
  nominees_avg_order_by: {
    circle_id: 'order_by',
    id: 'order_by',
    nominated_by_user_id: 'order_by',
    user_id: 'order_by',
    vouches_required: 'order_by',
  },
  nominees_bool_exp: {
    _and: 'nominees_bool_exp',
    _not: 'nominees_bool_exp',
    _or: 'nominees_bool_exp',
    address: 'String_comparison_exp',
    circle: 'circles_bool_exp',
    circle_id: 'Int_comparison_exp',
    created_at: 'timestamp_comparison_exp',
    description: 'String_comparison_exp',
    ended: 'Boolean_comparison_exp',
    expiry_date: 'timestamp_comparison_exp',
    id: 'bigint_comparison_exp',
    name: 'String_comparison_exp',
    nominated_by_user_id: 'Int_comparison_exp',
    nominated_date: 'date_comparison_exp',
    nominations: 'vouches_bool_exp',
    nominator: 'users_bool_exp',
    updated_at: 'timestamp_comparison_exp',
    user: 'users_bool_exp',
    user_id: 'Int_comparison_exp',
    vouches_required: 'Int_comparison_exp',
  },
  nominees_max_order_by: {
    address: 'order_by',
    circle_id: 'order_by',
    created_at: 'order_by',
    description: 'order_by',
    expiry_date: 'order_by',
    id: 'order_by',
    name: 'order_by',
    nominated_by_user_id: 'order_by',
    nominated_date: 'order_by',
    updated_at: 'order_by',
    user_id: 'order_by',
    vouches_required: 'order_by',
  },
  nominees_min_order_by: {
    address: 'order_by',
    circle_id: 'order_by',
    created_at: 'order_by',
    description: 'order_by',
    expiry_date: 'order_by',
    id: 'order_by',
    name: 'order_by',
    nominated_by_user_id: 'order_by',
    nominated_date: 'order_by',
    updated_at: 'order_by',
    user_id: 'order_by',
    vouches_required: 'order_by',
  },
  nominees_order_by: {
    address: 'order_by',
    circle: 'circles_order_by',
    circle_id: 'order_by',
    created_at: 'order_by',
    description: 'order_by',
    ended: 'order_by',
    expiry_date: 'order_by',
    id: 'order_by',
    name: 'order_by',
    nominated_by_user_id: 'order_by',
    nominated_date: 'order_by',
    nominations_aggregate: 'vouches_aggregate_order_by',
    nominator: 'users_order_by',
    updated_at: 'order_by',
    user: 'users_order_by',
    user_id: 'order_by',
    vouches_required: 'order_by',
  },
  nominees_select_column: true,
  nominees_stddev_order_by: {
    circle_id: 'order_by',
    id: 'order_by',
    nominated_by_user_id: 'order_by',
    user_id: 'order_by',
    vouches_required: 'order_by',
  },
  nominees_stddev_pop_order_by: {
    circle_id: 'order_by',
    id: 'order_by',
    nominated_by_user_id: 'order_by',
    user_id: 'order_by',
    vouches_required: 'order_by',
  },
  nominees_stddev_samp_order_by: {
    circle_id: 'order_by',
    id: 'order_by',
    nominated_by_user_id: 'order_by',
    user_id: 'order_by',
    vouches_required: 'order_by',
  },
  nominees_sum_order_by: {
    circle_id: 'order_by',
    id: 'order_by',
    nominated_by_user_id: 'order_by',
    user_id: 'order_by',
    vouches_required: 'order_by',
  },
  nominees_var_pop_order_by: {
    circle_id: 'order_by',
    id: 'order_by',
    nominated_by_user_id: 'order_by',
    user_id: 'order_by',
    vouches_required: 'order_by',
  },
  nominees_var_samp_order_by: {
    circle_id: 'order_by',
    id: 'order_by',
    nominated_by_user_id: 'order_by',
    user_id: 'order_by',
    vouches_required: 'order_by',
  },
  nominees_variance_order_by: {
    circle_id: 'order_by',
    id: 'order_by',
    nominated_by_user_id: 'order_by',
    user_id: 'order_by',
    vouches_required: 'order_by',
  },
  numeric: 'String',
  numeric_comparison_exp: {
    _eq: 'numeric',
    _gt: 'numeric',
    _gte: 'numeric',
    _in: 'numeric',
    _lt: 'numeric',
    _lte: 'numeric',
    _neq: 'numeric',
    _nin: 'numeric',
  },
  order_by: true,
  organizations: {
    circles: {
      distinct_on: 'circles_select_column',
      order_by: 'circles_order_by',
      where: 'circles_bool_exp',
    },
    vaults: {
      distinct_on: 'vaults_select_column',
      order_by: 'vaults_order_by',
      where: 'vaults_bool_exp',
    },
  },
  organizations_bool_exp: {
    _and: 'organizations_bool_exp',
    _not: 'organizations_bool_exp',
    _or: 'organizations_bool_exp',
    circles: 'circles_bool_exp',
    created_at: 'timestamp_comparison_exp',
    id: 'bigint_comparison_exp',
    logo: 'String_comparison_exp',
    name: 'String_comparison_exp',
    updated_at: 'timestamp_comparison_exp',
    vaults: 'vaults_bool_exp',
  },
  organizations_order_by: {
    circles_aggregate: 'circles_aggregate_order_by',
    created_at: 'order_by',
    id: 'order_by',
    logo: 'order_by',
    name: 'order_by',
    updated_at: 'order_by',
    vaults_aggregate: 'vaults_aggregate_order_by',
  },
  organizations_select_column: true,
  pending_gift_private_bool_exp: {
    _and: 'pending_gift_private_bool_exp',
    _not: 'pending_gift_private_bool_exp',
    _or: 'pending_gift_private_bool_exp',
    gift_id: 'bigint_comparison_exp',
    note: 'String_comparison_exp',
    recipient: 'users_bool_exp',
    recipient_id: 'bigint_comparison_exp',
    sender: 'users_bool_exp',
    sender_id: 'bigint_comparison_exp',
  },
  pending_gift_private_order_by: {
    gift_id: 'order_by',
    note: 'order_by',
    recipient: 'users_order_by',
    recipient_id: 'order_by',
    sender: 'users_order_by',
    sender_id: 'order_by',
  },
  pending_gift_private_select_column: true,
  pending_token_gifts_aggregate_order_by: {
    avg: 'pending_token_gifts_avg_order_by',
    count: 'order_by',
    max: 'pending_token_gifts_max_order_by',
    min: 'pending_token_gifts_min_order_by',
    stddev: 'pending_token_gifts_stddev_order_by',
    stddev_pop: 'pending_token_gifts_stddev_pop_order_by',
    stddev_samp: 'pending_token_gifts_stddev_samp_order_by',
    sum: 'pending_token_gifts_sum_order_by',
    var_pop: 'pending_token_gifts_var_pop_order_by',
    var_samp: 'pending_token_gifts_var_samp_order_by',
    variance: 'pending_token_gifts_variance_order_by',
  },
  pending_token_gifts_avg_order_by: {
    circle_id: 'order_by',
    epoch_id: 'order_by',
    id: 'order_by',
    recipient_id: 'order_by',
    sender_id: 'order_by',
    tokens: 'order_by',
  },
  pending_token_gifts_bool_exp: {
    _and: 'pending_token_gifts_bool_exp',
    _not: 'pending_token_gifts_bool_exp',
    _or: 'pending_token_gifts_bool_exp',
    circle: 'circles_bool_exp',
    circle_id: 'bigint_comparison_exp',
    created_at: 'timestamp_comparison_exp',
    dts_created: 'timestamp_comparison_exp',
    epoch: 'epochs_bool_exp',
    epoch_id: 'Int_comparison_exp',
    gift_private: 'pending_gift_private_bool_exp',
    id: 'bigint_comparison_exp',
    recipient: 'users_bool_exp',
    recipient_address: 'String_comparison_exp',
    recipient_id: 'bigint_comparison_exp',
    sender: 'users_bool_exp',
    sender_address: 'String_comparison_exp',
    sender_id: 'bigint_comparison_exp',
    tokens: 'Int_comparison_exp',
    updated_at: 'timestamp_comparison_exp',
  },
  pending_token_gifts_max_order_by: {
    circle_id: 'order_by',
    created_at: 'order_by',
    dts_created: 'order_by',
    epoch_id: 'order_by',
    id: 'order_by',
    recipient_address: 'order_by',
    recipient_id: 'order_by',
    sender_address: 'order_by',
    sender_id: 'order_by',
    tokens: 'order_by',
    updated_at: 'order_by',
  },
  pending_token_gifts_min_order_by: {
    circle_id: 'order_by',
    created_at: 'order_by',
    dts_created: 'order_by',
    epoch_id: 'order_by',
    id: 'order_by',
    recipient_address: 'order_by',
    recipient_id: 'order_by',
    sender_address: 'order_by',
    sender_id: 'order_by',
    tokens: 'order_by',
    updated_at: 'order_by',
  },
  pending_token_gifts_order_by: {
    circle: 'circles_order_by',
    circle_id: 'order_by',
    created_at: 'order_by',
    dts_created: 'order_by',
    epoch: 'epochs_order_by',
    epoch_id: 'order_by',
    gift_private: 'pending_gift_private_order_by',
    id: 'order_by',
    recipient: 'users_order_by',
    recipient_address: 'order_by',
    recipient_id: 'order_by',
    sender: 'users_order_by',
    sender_address: 'order_by',
    sender_id: 'order_by',
    tokens: 'order_by',
    updated_at: 'order_by',
  },
  pending_token_gifts_select_column: true,
  pending_token_gifts_stddev_order_by: {
    circle_id: 'order_by',
    epoch_id: 'order_by',
    id: 'order_by',
    recipient_id: 'order_by',
    sender_id: 'order_by',
    tokens: 'order_by',
  },
  pending_token_gifts_stddev_pop_order_by: {
    circle_id: 'order_by',
    epoch_id: 'order_by',
    id: 'order_by',
    recipient_id: 'order_by',
    sender_id: 'order_by',
    tokens: 'order_by',
  },
  pending_token_gifts_stddev_samp_order_by: {
    circle_id: 'order_by',
    epoch_id: 'order_by',
    id: 'order_by',
    recipient_id: 'order_by',
    sender_id: 'order_by',
    tokens: 'order_by',
  },
  pending_token_gifts_sum_order_by: {
    circle_id: 'order_by',
    epoch_id: 'order_by',
    id: 'order_by',
    recipient_id: 'order_by',
    sender_id: 'order_by',
    tokens: 'order_by',
  },
  pending_token_gifts_var_pop_order_by: {
    circle_id: 'order_by',
    epoch_id: 'order_by',
    id: 'order_by',
    recipient_id: 'order_by',
    sender_id: 'order_by',
    tokens: 'order_by',
  },
  pending_token_gifts_var_samp_order_by: {
    circle_id: 'order_by',
    epoch_id: 'order_by',
    id: 'order_by',
    recipient_id: 'order_by',
    sender_id: 'order_by',
    tokens: 'order_by',
  },
  pending_token_gifts_variance_order_by: {
    circle_id: 'order_by',
    epoch_id: 'order_by',
    id: 'order_by',
    recipient_id: 'order_by',
    sender_id: 'order_by',
    tokens: 'order_by',
  },
  profiles: {
    users: {
      distinct_on: 'users_select_column',
      order_by: 'users_order_by',
      where: 'users_bool_exp',
    },
  },
  profiles_bool_exp: {
    _and: 'profiles_bool_exp',
    _not: 'profiles_bool_exp',
    _or: 'profiles_bool_exp',
    address: 'String_comparison_exp',
    avatar: 'String_comparison_exp',
    background: 'String_comparison_exp',
    bio: 'String_comparison_exp',
    created_at: 'timestamp_comparison_exp',
    discord_username: 'String_comparison_exp',
    github_username: 'String_comparison_exp',
    id: 'bigint_comparison_exp',
    medium_username: 'String_comparison_exp',
    skills: 'String_comparison_exp',
    telegram_username: 'String_comparison_exp',
    twitter_username: 'String_comparison_exp',
    updated_at: 'timestamp_comparison_exp',
    users: 'users_bool_exp',
    website: 'String_comparison_exp',
  },
  profiles_order_by: {
    address: 'order_by',
    avatar: 'order_by',
    background: 'order_by',
    bio: 'order_by',
    created_at: 'order_by',
    discord_username: 'order_by',
    github_username: 'order_by',
    id: 'order_by',
    medium_username: 'order_by',
    skills: 'order_by',
    telegram_username: 'order_by',
    twitter_username: 'order_by',
    updated_at: 'order_by',
    users_aggregate: 'users_aggregate_order_by',
    website: 'order_by',
  },
  profiles_pk_columns_input: {
    id: 'bigint',
  },
  profiles_select_column: true,
  profiles_set_input: {},
  query_root: {
    burns: {
      distinct_on: 'burns_select_column',
      order_by: 'burns_order_by',
      where: 'burns_bool_exp',
    },
    burns_by_pk: {
      id: 'bigint',
    },
    circle_api_keys: {
      distinct_on: 'circle_api_keys_select_column',
      order_by: 'circle_api_keys_order_by',
      where: 'circle_api_keys_bool_exp',
    },
    circle_api_keys_by_pk: {},
    circle_integrations: {
      distinct_on: 'circle_integrations_select_column',
      order_by: 'circle_integrations_order_by',
      where: 'circle_integrations_bool_exp',
    },
    circle_integrations_by_pk: {
      id: 'bigint',
    },
    circle_private: {
      distinct_on: 'circle_private_select_column',
      order_by: 'circle_private_order_by',
      where: 'circle_private_bool_exp',
    },
    circles: {
      distinct_on: 'circles_select_column',
      order_by: 'circles_order_by',
      where: 'circles_bool_exp',
    },
    circles_by_pk: {
      id: 'bigint',
    },
    claims: {
      distinct_on: 'claims_select_column',
      order_by: 'claims_order_by',
      where: 'claims_bool_exp',
    },
    claims_by_pk: {
      id: 'bigint',
    },
    distributions: {
      distinct_on: 'distributions_select_column',
      order_by: 'distributions_order_by',
      where: 'distributions_bool_exp',
    },
    distributions_aggregate: {
      distinct_on: 'distributions_select_column',
      order_by: 'distributions_order_by',
      where: 'distributions_bool_exp',
    },
    distributions_by_pk: {
      id: 'bigint',
    },
    epochs: {
      distinct_on: 'epochs_select_column',
      order_by: 'epochs_order_by',
      where: 'epochs_bool_exp',
    },
    epochs_by_pk: {
      id: 'bigint',
    },
    gift_private: {
      distinct_on: 'gift_private_select_column',
      order_by: 'gift_private_order_by',
      where: 'gift_private_bool_exp',
    },
    nominees: {
      distinct_on: 'nominees_select_column',
      order_by: 'nominees_order_by',
      where: 'nominees_bool_exp',
    },
    nominees_aggregate: {
      distinct_on: 'nominees_select_column',
      order_by: 'nominees_order_by',
      where: 'nominees_bool_exp',
    },
    nominees_by_pk: {
      id: 'bigint',
    },
    organizations: {
      distinct_on: 'organizations_select_column',
      order_by: 'organizations_order_by',
      where: 'organizations_bool_exp',
    },
    organizations_by_pk: {
      id: 'bigint',
    },
    pending_gift_private: {
      distinct_on: 'pending_gift_private_select_column',
      order_by: 'pending_gift_private_order_by',
      where: 'pending_gift_private_bool_exp',
    },
    pending_token_gifts: {
      distinct_on: 'pending_token_gifts_select_column',
      order_by: 'pending_token_gifts_order_by',
      where: 'pending_token_gifts_bool_exp',
    },
    pending_token_gifts_by_pk: {
      id: 'bigint',
    },
    profiles: {
      distinct_on: 'profiles_select_column',
      order_by: 'profiles_order_by',
      where: 'profiles_bool_exp',
    },
    profiles_by_pk: {
      id: 'bigint',
    },
    teammates: {
      distinct_on: 'teammates_select_column',
      order_by: 'teammates_order_by',
      where: 'teammates_bool_exp',
    },
    teammates_by_pk: {
      id: 'bigint',
    },
    token_gifts: {
      distinct_on: 'token_gifts_select_column',
      order_by: 'token_gifts_order_by',
      where: 'token_gifts_bool_exp',
    },
    token_gifts_aggregate: {
      distinct_on: 'token_gifts_select_column',
      order_by: 'token_gifts_order_by',
      where: 'token_gifts_bool_exp',
    },
    token_gifts_by_pk: {
      id: 'bigint',
    },
    user_private: {
      distinct_on: 'user_private_select_column',
      order_by: 'user_private_order_by',
      where: 'user_private_bool_exp',
    },
    users: {
      distinct_on: 'users_select_column',
      order_by: 'users_order_by',
      where: 'users_bool_exp',
    },
    users_by_pk: {
      id: 'bigint',
    },
    vault_transactions: {
      distinct_on: 'vault_transactions_select_column',
      order_by: 'vault_transactions_order_by',
      where: 'vault_transactions_bool_exp',
    },
    vault_transactions_by_pk: {
      id: 'bigint',
    },
    vaults: {
      distinct_on: 'vaults_select_column',
      order_by: 'vaults_order_by',
      where: 'vaults_bool_exp',
    },
    vaults_by_pk: {
      id: 'bigint',
    },
    vouches: {
      distinct_on: 'vouches_select_column',
      order_by: 'vouches_order_by',
      where: 'vouches_bool_exp',
    },
    vouches_by_pk: {
      id: 'bigint',
    },
  },
  subscription_root: {
    burns: {
      distinct_on: 'burns_select_column',
      order_by: 'burns_order_by',
      where: 'burns_bool_exp',
    },
    burns_by_pk: {
      id: 'bigint',
    },
    circle_api_keys: {
      distinct_on: 'circle_api_keys_select_column',
      order_by: 'circle_api_keys_order_by',
      where: 'circle_api_keys_bool_exp',
    },
    circle_api_keys_by_pk: {},
    circle_integrations: {
      distinct_on: 'circle_integrations_select_column',
      order_by: 'circle_integrations_order_by',
      where: 'circle_integrations_bool_exp',
    },
    circle_integrations_by_pk: {
      id: 'bigint',
    },
    circle_private: {
      distinct_on: 'circle_private_select_column',
      order_by: 'circle_private_order_by',
      where: 'circle_private_bool_exp',
    },
    circles: {
      distinct_on: 'circles_select_column',
      order_by: 'circles_order_by',
      where: 'circles_bool_exp',
    },
    circles_by_pk: {
      id: 'bigint',
    },
    claims: {
      distinct_on: 'claims_select_column',
      order_by: 'claims_order_by',
      where: 'claims_bool_exp',
    },
    claims_by_pk: {
      id: 'bigint',
    },
    distributions: {
      distinct_on: 'distributions_select_column',
      order_by: 'distributions_order_by',
      where: 'distributions_bool_exp',
    },
    distributions_aggregate: {
      distinct_on: 'distributions_select_column',
      order_by: 'distributions_order_by',
      where: 'distributions_bool_exp',
    },
    distributions_by_pk: {
      id: 'bigint',
    },
    epochs: {
      distinct_on: 'epochs_select_column',
      order_by: 'epochs_order_by',
      where: 'epochs_bool_exp',
    },
    epochs_by_pk: {
      id: 'bigint',
    },
    gift_private: {
      distinct_on: 'gift_private_select_column',
      order_by: 'gift_private_order_by',
      where: 'gift_private_bool_exp',
    },
    nominees: {
      distinct_on: 'nominees_select_column',
      order_by: 'nominees_order_by',
      where: 'nominees_bool_exp',
    },
    nominees_aggregate: {
      distinct_on: 'nominees_select_column',
      order_by: 'nominees_order_by',
      where: 'nominees_bool_exp',
    },
    nominees_by_pk: {
      id: 'bigint',
    },
    organizations: {
      distinct_on: 'organizations_select_column',
      order_by: 'organizations_order_by',
      where: 'organizations_bool_exp',
    },
    organizations_by_pk: {
      id: 'bigint',
    },
    pending_gift_private: {
      distinct_on: 'pending_gift_private_select_column',
      order_by: 'pending_gift_private_order_by',
      where: 'pending_gift_private_bool_exp',
    },
    pending_token_gifts: {
      distinct_on: 'pending_token_gifts_select_column',
      order_by: 'pending_token_gifts_order_by',
      where: 'pending_token_gifts_bool_exp',
    },
    pending_token_gifts_by_pk: {
      id: 'bigint',
    },
    profiles: {
      distinct_on: 'profiles_select_column',
      order_by: 'profiles_order_by',
      where: 'profiles_bool_exp',
    },
    profiles_by_pk: {
      id: 'bigint',
    },
    teammates: {
      distinct_on: 'teammates_select_column',
      order_by: 'teammates_order_by',
      where: 'teammates_bool_exp',
    },
    teammates_by_pk: {
      id: 'bigint',
    },
    token_gifts: {
      distinct_on: 'token_gifts_select_column',
      order_by: 'token_gifts_order_by',
      where: 'token_gifts_bool_exp',
    },
    token_gifts_aggregate: {
      distinct_on: 'token_gifts_select_column',
      order_by: 'token_gifts_order_by',
      where: 'token_gifts_bool_exp',
    },
    token_gifts_by_pk: {
      id: 'bigint',
    },
    user_private: {
      distinct_on: 'user_private_select_column',
      order_by: 'user_private_order_by',
      where: 'user_private_bool_exp',
    },
    users: {
      distinct_on: 'users_select_column',
      order_by: 'users_order_by',
      where: 'users_bool_exp',
    },
    users_by_pk: {
      id: 'bigint',
    },
    vault_transactions: {
      distinct_on: 'vault_transactions_select_column',
      order_by: 'vault_transactions_order_by',
      where: 'vault_transactions_bool_exp',
    },
    vault_transactions_by_pk: {
      id: 'bigint',
    },
    vaults: {
      distinct_on: 'vaults_select_column',
      order_by: 'vaults_order_by',
      where: 'vaults_bool_exp',
    },
    vaults_by_pk: {
      id: 'bigint',
    },
    vouches: {
      distinct_on: 'vouches_select_column',
      order_by: 'vouches_order_by',
      where: 'vouches_bool_exp',
    },
    vouches_by_pk: {
      id: 'bigint',
    },
  },
  teammates_aggregate_order_by: {
    avg: 'teammates_avg_order_by',
    count: 'order_by',
    max: 'teammates_max_order_by',
    min: 'teammates_min_order_by',
    stddev: 'teammates_stddev_order_by',
    stddev_pop: 'teammates_stddev_pop_order_by',
    stddev_samp: 'teammates_stddev_samp_order_by',
    sum: 'teammates_sum_order_by',
    var_pop: 'teammates_var_pop_order_by',
    var_samp: 'teammates_var_samp_order_by',
    variance: 'teammates_variance_order_by',
  },
  teammates_avg_order_by: {
    id: 'order_by',
    team_mate_id: 'order_by',
    user_id: 'order_by',
  },
  teammates_bool_exp: {
    _and: 'teammates_bool_exp',
    _not: 'teammates_bool_exp',
    _or: 'teammates_bool_exp',
    created_at: 'timestamp_comparison_exp',
    id: 'bigint_comparison_exp',
    team_mate_id: 'Int_comparison_exp',
    teammate: 'users_bool_exp',
    updated_at: 'timestamp_comparison_exp',
    user: 'users_bool_exp',
    user_id: 'Int_comparison_exp',
  },
  teammates_max_order_by: {
    created_at: 'order_by',
    id: 'order_by',
    team_mate_id: 'order_by',
    updated_at: 'order_by',
    user_id: 'order_by',
  },
  teammates_min_order_by: {
    created_at: 'order_by',
    id: 'order_by',
    team_mate_id: 'order_by',
    updated_at: 'order_by',
    user_id: 'order_by',
  },
  teammates_order_by: {
    created_at: 'order_by',
    id: 'order_by',
    team_mate_id: 'order_by',
    teammate: 'users_order_by',
    updated_at: 'order_by',
    user: 'users_order_by',
    user_id: 'order_by',
  },
  teammates_select_column: true,
  teammates_stddev_order_by: {
    id: 'order_by',
    team_mate_id: 'order_by',
    user_id: 'order_by',
  },
  teammates_stddev_pop_order_by: {
    id: 'order_by',
    team_mate_id: 'order_by',
    user_id: 'order_by',
  },
  teammates_stddev_samp_order_by: {
    id: 'order_by',
    team_mate_id: 'order_by',
    user_id: 'order_by',
  },
  teammates_sum_order_by: {
    id: 'order_by',
    team_mate_id: 'order_by',
    user_id: 'order_by',
  },
  teammates_var_pop_order_by: {
    id: 'order_by',
    team_mate_id: 'order_by',
    user_id: 'order_by',
  },
  teammates_var_samp_order_by: {
    id: 'order_by',
    team_mate_id: 'order_by',
    user_id: 'order_by',
  },
  teammates_variance_order_by: {
    id: 'order_by',
    team_mate_id: 'order_by',
    user_id: 'order_by',
  },
  timestamp: 'String',
  timestamp_comparison_exp: {
    _eq: 'timestamp',
    _gt: 'timestamp',
    _gte: 'timestamp',
    _in: 'timestamp',
    _lt: 'timestamp',
    _lte: 'timestamp',
    _neq: 'timestamp',
    _nin: 'timestamp',
  },
  timestamptz: 'String',
  timestamptz_comparison_exp: {
    _eq: 'timestamptz',
    _gt: 'timestamptz',
    _gte: 'timestamptz',
    _in: 'timestamptz',
    _lt: 'timestamptz',
    _lte: 'timestamptz',
    _neq: 'timestamptz',
    _nin: 'timestamptz',
  },
  token_gifts_aggregate_fields: {
    count: {
      columns: 'token_gifts_select_column',
    },
  },
  token_gifts_aggregate_order_by: {
    avg: 'token_gifts_avg_order_by',
    count: 'order_by',
    max: 'token_gifts_max_order_by',
    min: 'token_gifts_min_order_by',
    stddev: 'token_gifts_stddev_order_by',
    stddev_pop: 'token_gifts_stddev_pop_order_by',
    stddev_samp: 'token_gifts_stddev_samp_order_by',
    sum: 'token_gifts_sum_order_by',
    var_pop: 'token_gifts_var_pop_order_by',
    var_samp: 'token_gifts_var_samp_order_by',
    variance: 'token_gifts_variance_order_by',
  },
  token_gifts_avg_order_by: {
    circle_id: 'order_by',
    epoch_id: 'order_by',
    id: 'order_by',
    recipient_id: 'order_by',
    sender_id: 'order_by',
    tokens: 'order_by',
  },
  token_gifts_bool_exp: {
    _and: 'token_gifts_bool_exp',
    _not: 'token_gifts_bool_exp',
    _or: 'token_gifts_bool_exp',
    circle: 'circles_bool_exp',
    circle_id: 'bigint_comparison_exp',
    created_at: 'timestamp_comparison_exp',
    dts_created: 'timestamp_comparison_exp',
    epoch_id: 'Int_comparison_exp',
    gift_private: 'gift_private_bool_exp',
    id: 'bigint_comparison_exp',
    recipient: 'users_bool_exp',
    recipient_address: 'String_comparison_exp',
    recipient_id: 'bigint_comparison_exp',
    sender: 'users_bool_exp',
    sender_address: 'String_comparison_exp',
    sender_id: 'bigint_comparison_exp',
    tokens: 'Int_comparison_exp',
    updated_at: 'timestamp_comparison_exp',
  },
  token_gifts_max_order_by: {
    circle_id: 'order_by',
    created_at: 'order_by',
    dts_created: 'order_by',
    epoch_id: 'order_by',
    id: 'order_by',
    recipient_address: 'order_by',
    recipient_id: 'order_by',
    sender_address: 'order_by',
    sender_id: 'order_by',
    tokens: 'order_by',
    updated_at: 'order_by',
  },
  token_gifts_min_order_by: {
    circle_id: 'order_by',
    created_at: 'order_by',
    dts_created: 'order_by',
    epoch_id: 'order_by',
    id: 'order_by',
    recipient_address: 'order_by',
    recipient_id: 'order_by',
    sender_address: 'order_by',
    sender_id: 'order_by',
    tokens: 'order_by',
    updated_at: 'order_by',
  },
  token_gifts_order_by: {
    circle: 'circles_order_by',
    circle_id: 'order_by',
    created_at: 'order_by',
    dts_created: 'order_by',
    epoch_id: 'order_by',
    gift_private: 'gift_private_order_by',
    id: 'order_by',
    recipient: 'users_order_by',
    recipient_address: 'order_by',
    recipient_id: 'order_by',
    sender: 'users_order_by',
    sender_address: 'order_by',
    sender_id: 'order_by',
    tokens: 'order_by',
    updated_at: 'order_by',
  },
  token_gifts_select_column: true,
  token_gifts_stddev_order_by: {
    circle_id: 'order_by',
    epoch_id: 'order_by',
    id: 'order_by',
    recipient_id: 'order_by',
    sender_id: 'order_by',
    tokens: 'order_by',
  },
  token_gifts_stddev_pop_order_by: {
    circle_id: 'order_by',
    epoch_id: 'order_by',
    id: 'order_by',
    recipient_id: 'order_by',
    sender_id: 'order_by',
    tokens: 'order_by',
  },
  token_gifts_stddev_samp_order_by: {
    circle_id: 'order_by',
    epoch_id: 'order_by',
    id: 'order_by',
    recipient_id: 'order_by',
    sender_id: 'order_by',
    tokens: 'order_by',
  },
  token_gifts_sum_order_by: {
    circle_id: 'order_by',
    epoch_id: 'order_by',
    id: 'order_by',
    recipient_id: 'order_by',
    sender_id: 'order_by',
    tokens: 'order_by',
  },
  token_gifts_var_pop_order_by: {
    circle_id: 'order_by',
    epoch_id: 'order_by',
    id: 'order_by',
    recipient_id: 'order_by',
    sender_id: 'order_by',
    tokens: 'order_by',
  },
  token_gifts_var_samp_order_by: {
    circle_id: 'order_by',
    epoch_id: 'order_by',
    id: 'order_by',
    recipient_id: 'order_by',
    sender_id: 'order_by',
    tokens: 'order_by',
  },
  token_gifts_variance_order_by: {
    circle_id: 'order_by',
    epoch_id: 'order_by',
    id: 'order_by',
    recipient_id: 'order_by',
    sender_id: 'order_by',
    tokens: 'order_by',
  },
  user_private_bool_exp: {
    _and: 'user_private_bool_exp',
    _not: 'user_private_bool_exp',
    _or: 'user_private_bool_exp',
    circle: 'circles_bool_exp',
    fixed_payment_amount: 'numeric_comparison_exp',
    fixed_payment_token_type: 'String_comparison_exp',
    user: 'users_bool_exp',
    user_id: 'bigint_comparison_exp',
  },
  user_private_order_by: {
    circle: 'circles_order_by',
    fixed_payment_amount: 'order_by',
    fixed_payment_token_type: 'order_by',
    user: 'users_order_by',
    user_id: 'order_by',
  },
  user_private_select_column: true,
  users: {
    burns: {
      distinct_on: 'burns_select_column',
      order_by: 'burns_order_by',
      where: 'burns_bool_exp',
    },
    pending_received_gifts: {
      distinct_on: 'pending_token_gifts_select_column',
      order_by: 'pending_token_gifts_order_by',
      where: 'pending_token_gifts_bool_exp',
    },
    pending_sent_gifts: {
      distinct_on: 'pending_token_gifts_select_column',
      order_by: 'pending_token_gifts_order_by',
      where: 'pending_token_gifts_bool_exp',
    },
    received_gifts: {
      distinct_on: 'token_gifts_select_column',
      order_by: 'token_gifts_order_by',
      where: 'token_gifts_bool_exp',
    },
    received_gifts_aggregate: {
      distinct_on: 'token_gifts_select_column',
      order_by: 'token_gifts_order_by',
      where: 'token_gifts_bool_exp',
    },
    sent_gifts: {
      distinct_on: 'token_gifts_select_column',
      order_by: 'token_gifts_order_by',
      where: 'token_gifts_bool_exp',
    },
    sent_gifts_aggregate: {
      distinct_on: 'token_gifts_select_column',
      order_by: 'token_gifts_order_by',
      where: 'token_gifts_bool_exp',
    },
    teammates: {
      distinct_on: 'teammates_select_column',
      order_by: 'teammates_order_by',
      where: 'teammates_bool_exp',
    },
  },
  users_aggregate_order_by: {
    avg: 'users_avg_order_by',
    count: 'order_by',
    max: 'users_max_order_by',
    min: 'users_min_order_by',
    stddev: 'users_stddev_order_by',
    stddev_pop: 'users_stddev_pop_order_by',
    stddev_samp: 'users_stddev_samp_order_by',
    sum: 'users_sum_order_by',
    var_pop: 'users_var_pop_order_by',
    var_samp: 'users_var_samp_order_by',
    variance: 'users_variance_order_by',
  },
  users_avg_order_by: {
    circle_id: 'order_by',
    give_token_received: 'order_by',
    give_token_remaining: 'order_by',
    id: 'order_by',
    role: 'order_by',
    starting_tokens: 'order_by',
  },
  users_bool_exp: {
    _and: 'users_bool_exp',
    _not: 'users_bool_exp',
    _or: 'users_bool_exp',
    address: 'String_comparison_exp',
    bio: 'String_comparison_exp',
    burns: 'burns_bool_exp',
    circle: 'circles_bool_exp',
    circle_id: 'bigint_comparison_exp',
    created_at: 'timestamp_comparison_exp',
    deleted_at: 'timestamp_comparison_exp',
    epoch_first_visit: 'Boolean_comparison_exp',
    fixed_non_receiver: 'Boolean_comparison_exp',
    give_token_received: 'Int_comparison_exp',
    give_token_remaining: 'Int_comparison_exp',
    id: 'bigint_comparison_exp',
    name: 'String_comparison_exp',
    non_giver: 'Boolean_comparison_exp',
    non_receiver: 'Boolean_comparison_exp',
    pending_received_gifts: 'pending_token_gifts_bool_exp',
    pending_sent_gifts: 'pending_token_gifts_bool_exp',
    profile: 'profiles_bool_exp',
    received_gifts: 'token_gifts_bool_exp',
    role: 'Int_comparison_exp',
    sent_gifts: 'token_gifts_bool_exp',
    starting_tokens: 'Int_comparison_exp',
    teammates: 'teammates_bool_exp',
    updated_at: 'timestamp_comparison_exp',
    user_private: 'user_private_bool_exp',
  },
  users_max_order_by: {
    address: 'order_by',
    bio: 'order_by',
    circle_id: 'order_by',
    created_at: 'order_by',
    deleted_at: 'order_by',
    give_token_received: 'order_by',
    give_token_remaining: 'order_by',
    id: 'order_by',
    name: 'order_by',
    role: 'order_by',
    starting_tokens: 'order_by',
    updated_at: 'order_by',
  },
  users_min_order_by: {
    address: 'order_by',
    bio: 'order_by',
    circle_id: 'order_by',
    created_at: 'order_by',
    deleted_at: 'order_by',
    give_token_received: 'order_by',
    give_token_remaining: 'order_by',
    id: 'order_by',
    name: 'order_by',
    role: 'order_by',
    starting_tokens: 'order_by',
    updated_at: 'order_by',
  },
  users_order_by: {
    address: 'order_by',
    bio: 'order_by',
    burns_aggregate: 'burns_aggregate_order_by',
    circle: 'circles_order_by',
    circle_id: 'order_by',
    created_at: 'order_by',
    deleted_at: 'order_by',
    epoch_first_visit: 'order_by',
    fixed_non_receiver: 'order_by',
    give_token_received: 'order_by',
    give_token_remaining: 'order_by',
    id: 'order_by',
    name: 'order_by',
    non_giver: 'order_by',
    non_receiver: 'order_by',
    pending_received_gifts_aggregate: 'pending_token_gifts_aggregate_order_by',
    pending_sent_gifts_aggregate: 'pending_token_gifts_aggregate_order_by',
    profile: 'profiles_order_by',
    received_gifts_aggregate: 'token_gifts_aggregate_order_by',
    role: 'order_by',
    sent_gifts_aggregate: 'token_gifts_aggregate_order_by',
    starting_tokens: 'order_by',
    teammates_aggregate: 'teammates_aggregate_order_by',
    updated_at: 'order_by',
    user_private: 'user_private_order_by',
  },
  users_select_column: true,
  users_stddev_order_by: {
    circle_id: 'order_by',
    give_token_received: 'order_by',
    give_token_remaining: 'order_by',
    id: 'order_by',
    role: 'order_by',
    starting_tokens: 'order_by',
  },
  users_stddev_pop_order_by: {
    circle_id: 'order_by',
    give_token_received: 'order_by',
    give_token_remaining: 'order_by',
    id: 'order_by',
    role: 'order_by',
    starting_tokens: 'order_by',
  },
  users_stddev_samp_order_by: {
    circle_id: 'order_by',
    give_token_received: 'order_by',
    give_token_remaining: 'order_by',
    id: 'order_by',
    role: 'order_by',
    starting_tokens: 'order_by',
  },
  users_sum_order_by: {
    circle_id: 'order_by',
    give_token_received: 'order_by',
    give_token_remaining: 'order_by',
    id: 'order_by',
    role: 'order_by',
    starting_tokens: 'order_by',
  },
  users_var_pop_order_by: {
    circle_id: 'order_by',
    give_token_received: 'order_by',
    give_token_remaining: 'order_by',
    id: 'order_by',
    role: 'order_by',
    starting_tokens: 'order_by',
  },
  users_var_samp_order_by: {
    circle_id: 'order_by',
    give_token_received: 'order_by',
    give_token_remaining: 'order_by',
    id: 'order_by',
    role: 'order_by',
    starting_tokens: 'order_by',
  },
  users_variance_order_by: {
    circle_id: 'order_by',
    give_token_received: 'order_by',
    give_token_remaining: 'order_by',
    id: 'order_by',
    role: 'order_by',
    starting_tokens: 'order_by',
  },
  vault_transactions_aggregate_order_by: {
    avg: 'vault_transactions_avg_order_by',
    count: 'order_by',
    max: 'vault_transactions_max_order_by',
    min: 'vault_transactions_min_order_by',
    stddev: 'vault_transactions_stddev_order_by',
    stddev_pop: 'vault_transactions_stddev_pop_order_by',
    stddev_samp: 'vault_transactions_stddev_samp_order_by',
    sum: 'vault_transactions_sum_order_by',
    var_pop: 'vault_transactions_var_pop_order_by',
    var_samp: 'vault_transactions_var_samp_order_by',
    variance: 'vault_transactions_variance_order_by',
  },
  vault_transactions_avg_order_by: {
    created_by: 'order_by',
    id: 'order_by',
    value: 'order_by',
    vault_id: 'order_by',
  },
  vault_transactions_bool_exp: {
    _and: 'vault_transactions_bool_exp',
    _not: 'vault_transactions_bool_exp',
    _or: 'vault_transactions_bool_exp',
    created_at: 'timestamp_comparison_exp',
    created_by: 'bigint_comparison_exp',
    date: 'date_comparison_exp',
    description: 'String_comparison_exp',
    id: 'bigint_comparison_exp',
    name: 'String_comparison_exp',
    tx_hash: 'String_comparison_exp',
    updated_at: 'timestamp_comparison_exp',
    user: 'users_bool_exp',
    value: 'bigint_comparison_exp',
    vault: 'vaults_bool_exp',
    vault_id: 'bigint_comparison_exp',
  },
  vault_transactions_insert_input: {
    created_at: 'timestamp',
    created_by: 'bigint',
    date: 'date',
    id: 'bigint',
    updated_at: 'timestamp',
    value: 'bigint',
    vault_id: 'bigint',
  },
  vault_transactions_max_order_by: {
    created_at: 'order_by',
    created_by: 'order_by',
    date: 'order_by',
    description: 'order_by',
    id: 'order_by',
    name: 'order_by',
    tx_hash: 'order_by',
    updated_at: 'order_by',
    value: 'order_by',
    vault_id: 'order_by',
  },
  vault_transactions_min_order_by: {
    created_at: 'order_by',
    created_by: 'order_by',
    date: 'order_by',
    description: 'order_by',
    id: 'order_by',
    name: 'order_by',
    tx_hash: 'order_by',
    updated_at: 'order_by',
    value: 'order_by',
    vault_id: 'order_by',
  },
  vault_transactions_order_by: {
    created_at: 'order_by',
    created_by: 'order_by',
    date: 'order_by',
    description: 'order_by',
    id: 'order_by',
    name: 'order_by',
    tx_hash: 'order_by',
    updated_at: 'order_by',
    user: 'users_order_by',
    value: 'order_by',
    vault: 'vaults_order_by',
    vault_id: 'order_by',
  },
  vault_transactions_select_column: true,
  vault_transactions_stddev_order_by: {
    created_by: 'order_by',
    id: 'order_by',
    value: 'order_by',
    vault_id: 'order_by',
  },
  vault_transactions_stddev_pop_order_by: {
    created_by: 'order_by',
    id: 'order_by',
    value: 'order_by',
    vault_id: 'order_by',
  },
  vault_transactions_stddev_samp_order_by: {
    created_by: 'order_by',
    id: 'order_by',
    value: 'order_by',
    vault_id: 'order_by',
  },
  vault_transactions_sum_order_by: {
    created_by: 'order_by',
    id: 'order_by',
    value: 'order_by',
    vault_id: 'order_by',
  },
  vault_transactions_var_pop_order_by: {
    created_by: 'order_by',
    id: 'order_by',
    value: 'order_by',
    vault_id: 'order_by',
  },
  vault_transactions_var_samp_order_by: {
    created_by: 'order_by',
    id: 'order_by',
    value: 'order_by',
    vault_id: 'order_by',
  },
  vault_transactions_variance_order_by: {
    created_by: 'order_by',
    id: 'order_by',
    value: 'order_by',
    vault_id: 'order_by',
  },
  vaults: {
    vault_transactions: {
      distinct_on: 'vault_transactions_select_column',
      order_by: 'vault_transactions_order_by',
      where: 'vault_transactions_bool_exp',
    },
  },
  vaults_aggregate_order_by: {
    avg: 'vaults_avg_order_by',
    count: 'order_by',
    max: 'vaults_max_order_by',
    min: 'vaults_min_order_by',
    stddev: 'vaults_stddev_order_by',
    stddev_pop: 'vaults_stddev_pop_order_by',
    stddev_samp: 'vaults_stddev_samp_order_by',
    sum: 'vaults_sum_order_by',
    var_pop: 'vaults_var_pop_order_by',
    var_samp: 'vaults_var_samp_order_by',
    variance: 'vaults_variance_order_by',
  },
  vaults_avg_order_by: {
    chain_id: 'order_by',
    created_by: 'order_by',
    decimals: 'order_by',
    id: 'order_by',
    org_id: 'order_by',
  },
  vaults_bool_exp: {
    _and: 'vaults_bool_exp',
    _not: 'vaults_bool_exp',
    _or: 'vaults_bool_exp',
    chain_id: 'Int_comparison_exp',
    created_at: 'timestamptz_comparison_exp',
    created_by: 'bigint_comparison_exp',
    decimals: 'Int_comparison_exp',
    id: 'bigint_comparison_exp',
    org_id: 'bigint_comparison_exp',
    profile: 'profiles_bool_exp',
    protocol: 'organizations_bool_exp',
    simple_token_address: 'String_comparison_exp',
    symbol: 'String_comparison_exp',
    token_address: 'String_comparison_exp',
    updated_at: 'timestamptz_comparison_exp',
    vault_address: 'String_comparison_exp',
    vault_transactions: 'vault_transactions_bool_exp',
  },
  vaults_max_order_by: {
    chain_id: 'order_by',
    created_at: 'order_by',
    created_by: 'order_by',
    decimals: 'order_by',
    id: 'order_by',
    org_id: 'order_by',
    simple_token_address: 'order_by',
    symbol: 'order_by',
    token_address: 'order_by',
    updated_at: 'order_by',
    vault_address: 'order_by',
  },
  vaults_min_order_by: {
    chain_id: 'order_by',
    created_at: 'order_by',
    created_by: 'order_by',
    decimals: 'order_by',
    id: 'order_by',
    org_id: 'order_by',
    simple_token_address: 'order_by',
    symbol: 'order_by',
    token_address: 'order_by',
    updated_at: 'order_by',
    vault_address: 'order_by',
  },
  vaults_order_by: {
    chain_id: 'order_by',
    created_at: 'order_by',
    created_by: 'order_by',
    decimals: 'order_by',
    id: 'order_by',
    org_id: 'order_by',
    profile: 'profiles_order_by',
    protocol: 'organizations_order_by',
    simple_token_address: 'order_by',
    symbol: 'order_by',
    token_address: 'order_by',
    updated_at: 'order_by',
    vault_address: 'order_by',
    vault_transactions_aggregate: 'vault_transactions_aggregate_order_by',
  },
  vaults_select_column: true,
  vaults_stddev_order_by: {
    chain_id: 'order_by',
    created_by: 'order_by',
    decimals: 'order_by',
    id: 'order_by',
    org_id: 'order_by',
  },
  vaults_stddev_pop_order_by: {
    chain_id: 'order_by',
    created_by: 'order_by',
    decimals: 'order_by',
    id: 'order_by',
    org_id: 'order_by',
  },
  vaults_stddev_samp_order_by: {
    chain_id: 'order_by',
    created_by: 'order_by',
    decimals: 'order_by',
    id: 'order_by',
    org_id: 'order_by',
  },
  vaults_sum_order_by: {
    chain_id: 'order_by',
    created_by: 'order_by',
    decimals: 'order_by',
    id: 'order_by',
    org_id: 'order_by',
  },
  vaults_var_pop_order_by: {
    chain_id: 'order_by',
    created_by: 'order_by',
    decimals: 'order_by',
    id: 'order_by',
    org_id: 'order_by',
  },
  vaults_var_samp_order_by: {
    chain_id: 'order_by',
    created_by: 'order_by',
    decimals: 'order_by',
    id: 'order_by',
    org_id: 'order_by',
  },
  vaults_variance_order_by: {
    chain_id: 'order_by',
    created_by: 'order_by',
    decimals: 'order_by',
    id: 'order_by',
    org_id: 'order_by',
  },
  vouches_aggregate_order_by: {
    avg: 'vouches_avg_order_by',
    count: 'order_by',
    max: 'vouches_max_order_by',
    min: 'vouches_min_order_by',
    stddev: 'vouches_stddev_order_by',
    stddev_pop: 'vouches_stddev_pop_order_by',
    stddev_samp: 'vouches_stddev_samp_order_by',
    sum: 'vouches_sum_order_by',
    var_pop: 'vouches_var_pop_order_by',
    var_samp: 'vouches_var_samp_order_by',
    variance: 'vouches_variance_order_by',
  },
  vouches_avg_order_by: {
    id: 'order_by',
    nominee_id: 'order_by',
    voucher_id: 'order_by',
  },
  vouches_bool_exp: {
    _and: 'vouches_bool_exp',
    _not: 'vouches_bool_exp',
    _or: 'vouches_bool_exp',
    created_at: 'timestamp_comparison_exp',
    id: 'bigint_comparison_exp',
    nominee: 'nominees_bool_exp',
    nominee_id: 'Int_comparison_exp',
    updated_at: 'timestamp_comparison_exp',
    voucher: 'users_bool_exp',
    voucher_id: 'Int_comparison_exp',
  },
  vouches_max_order_by: {
    created_at: 'order_by',
    id: 'order_by',
    nominee_id: 'order_by',
    updated_at: 'order_by',
    voucher_id: 'order_by',
  },
  vouches_min_order_by: {
    created_at: 'order_by',
    id: 'order_by',
    nominee_id: 'order_by',
    updated_at: 'order_by',
    voucher_id: 'order_by',
  },
  vouches_order_by: {
    created_at: 'order_by',
    id: 'order_by',
    nominee: 'nominees_order_by',
    nominee_id: 'order_by',
    updated_at: 'order_by',
    voucher: 'users_order_by',
    voucher_id: 'order_by',
  },
  vouches_select_column: true,
  vouches_stddev_order_by: {
    id: 'order_by',
    nominee_id: 'order_by',
    voucher_id: 'order_by',
  },
  vouches_stddev_pop_order_by: {
    id: 'order_by',
    nominee_id: 'order_by',
    voucher_id: 'order_by',
  },
  vouches_stddev_samp_order_by: {
    id: 'order_by',
    nominee_id: 'order_by',
    voucher_id: 'order_by',
  },
  vouches_sum_order_by: {
    id: 'order_by',
    nominee_id: 'order_by',
    voucher_id: 'order_by',
  },
  vouches_var_pop_order_by: {
    id: 'order_by',
    nominee_id: 'order_by',
    voucher_id: 'order_by',
  },
  vouches_var_samp_order_by: {
    id: 'order_by',
    nominee_id: 'order_by',
    voucher_id: 'order_by',
  },
  vouches_variance_order_by: {
    id: 'order_by',
    nominee_id: 'order_by',
    voucher_id: 'order_by',
  },
};

export const ReturnTypes: Record<string, any> = {
  cached: {
    ttl: 'Int',
    refresh: 'Boolean',
  },
  AllocationCsvResponse: {
    file: 'String',
  },
  AllocationsResponse: {
    user: 'users',
    user_id: 'Int',
  },
  ConfirmationResponse: {
    success: 'Boolean',
  },
  CreateCircleResponse: {
    circle: 'circles',
    id: 'Int',
    users: 'users',
  },
  CreateNomineeResponse: {
    id: 'Int',
    nominee: 'nominees',
  },
  DeleteEpochResponse: {
    success: 'Boolean',
  },
  EpochResponse: {
    epoch: 'epochs',
    id: 'ID',
  },
  LogoutResponse: {
    id: 'Int',
    profile: 'profiles',
  },
  UpdateCircleOutput: {
    circle: 'circles',
    id: 'Int',
  },
  UpdateCircleResponse: {
    circle: 'circles',
    id: 'Int',
  },
  UpdateOrgResponse: {
    id: 'Int',
    org: 'organizations',
  },
  UpdateProfileResponse: {
    id: 'Int',
    profile: 'profiles',
  },
  UpdateTeammatesResponse: {
    user: 'users',
    user_id: 'ID',
  },
  UserResponse: {
    UserResponse: 'users',
    id: 'ID',
  },
  VaultResponse: {
    id: 'ID',
    vault: 'vaults',
  },
  VouchOutput: {
    id: 'Int',
    nominee: 'nominees',
  },
  burns: {
    circle: 'circles',
    circle_id: 'bigint',
    created_at: 'timestamp',
    epoch: 'epochs',
    epoch_id: 'bigint',
    id: 'bigint',
    original_amount: 'Int',
    regift_percent: 'Int',
    tokens_burnt: 'Int',
    updated_at: 'timestamp',
    user: 'users',
    user_id: 'bigint',
  },
  circle_api_keys: {
    circle: 'circles',
    circle_id: 'bigint',
    create_vouches: 'Boolean',
    createdByUser: 'users',
    created_at: 'timestamptz',
    created_by: 'bigint',
    hash: 'String',
    name: 'String',
    read_circle: 'Boolean',
    read_epochs: 'Boolean',
    read_member_profiles: 'Boolean',
    read_nominees: 'Boolean',
    read_pending_token_gifts: 'Boolean',
    update_circle: 'Boolean',
    update_pending_token_gifts: 'Boolean',
  },
  circle_api_keys_mutation_response: {
    affected_rows: 'Int',
    returning: 'circle_api_keys',
  },
  circle_integrations: {
    circle: 'circles',
    circle_id: 'bigint',
    data: 'json',
    id: 'bigint',
    name: 'String',
    type: 'String',
  },
  circle_integrations_mutation_response: {
    affected_rows: 'Int',
    returning: 'circle_integrations',
  },
  circle_private: {
    circle: 'circles',
    circle_id: 'bigint',
    discord_webhook: 'String',
  },
  circles: {
    alloc_text: 'String',
    api_keys: 'circle_api_keys',
    auto_opt_out: 'Boolean',
    burns: 'burns',
    circle_private: 'circle_private',
    created_at: 'timestamp',
    default_opt_in: 'Boolean',
    epochs: 'epochs',
    fixed_payment_token_type: 'String',
    id: 'bigint',
    integrations: 'circle_integrations',
    is_verified: 'Boolean',
    logo: 'String',
    min_vouches: 'Int',
    name: 'String',
    nomination_days_limit: 'Int',
    nominees: 'nominees',
    nominees_aggregate: 'nominees_aggregate',
    only_giver_vouch: 'Boolean',
    organization: 'organizations',
    pending_token_gifts: 'pending_token_gifts',
    protocol_id: 'Int',
    team_sel_text: 'String',
    team_selection: 'Boolean',
    token_gifts: 'token_gifts',
    token_gifts_aggregate: 'token_gifts_aggregate',
    token_name: 'String',
    updated_at: 'timestamp',
    users: 'users',
    vouching: 'Boolean',
    vouching_text: 'String',
  },
  circles_mutation_response: {
    affected_rows: 'Int',
    returning: 'circles',
  },
  claims: {
    address: 'String',
    amount: 'numeric',
    claimed: 'Boolean',
    created_at: 'timestamptz',
    distribution: 'distributions',
    distribution_id: 'bigint',
    id: 'bigint',
    index: 'bigint',
    new_amount: 'numeric',
    proof: 'String',
    updated_at: 'timestamptz',
    user: 'users',
    user_id: 'bigint',
  },
  claims_mutation_response: {
    affected_rows: 'Int',
    returning: 'claims',
  },
  distributions: {
    claims: 'claims',
    created_at: 'timestamp',
    created_by: 'bigint',
    distribution_epoch_id: 'bigint',
    distribution_json: 'jsonb',
    epoch: 'epochs',
    epoch_id: 'bigint',
    id: 'bigint',
    merkle_root: 'String',
    total_amount: 'numeric',
    tx_hash: 'String',
    vault: 'vaults',
    vault_id: 'bigint',
  },
  distributions_aggregate: {
    aggregate: 'distributions_aggregate_fields',
    nodes: 'distributions',
  },
  distributions_aggregate_fields: {
    avg: 'distributions_avg_fields',
    count: 'Int',
    max: 'distributions_max_fields',
    min: 'distributions_min_fields',
    stddev: 'distributions_stddev_fields',
    stddev_pop: 'distributions_stddev_pop_fields',
    stddev_samp: 'distributions_stddev_samp_fields',
    sum: 'distributions_sum_fields',
    var_pop: 'distributions_var_pop_fields',
    var_samp: 'distributions_var_samp_fields',
    variance: 'distributions_variance_fields',
  },
  distributions_avg_fields: {
    created_by: 'Float',
    distribution_epoch_id: 'Float',
    epoch_id: 'Float',
    id: 'Float',
    total_amount: 'Float',
    vault_id: 'Float',
  },
  distributions_max_fields: {
    created_at: 'timestamp',
    created_by: 'bigint',
    distribution_epoch_id: 'bigint',
    epoch_id: 'bigint',
    id: 'bigint',
    merkle_root: 'String',
    total_amount: 'numeric',
    tx_hash: 'String',
    vault_id: 'bigint',
  },
  distributions_min_fields: {
    created_at: 'timestamp',
    created_by: 'bigint',
    distribution_epoch_id: 'bigint',
    epoch_id: 'bigint',
    id: 'bigint',
    merkle_root: 'String',
    total_amount: 'numeric',
    tx_hash: 'String',
    vault_id: 'bigint',
  },
  distributions_mutation_response: {
    affected_rows: 'Int',
    returning: 'distributions',
  },
  distributions_stddev_fields: {
    created_by: 'Float',
    distribution_epoch_id: 'Float',
    epoch_id: 'Float',
    id: 'Float',
    total_amount: 'Float',
    vault_id: 'Float',
  },
  distributions_stddev_pop_fields: {
    created_by: 'Float',
    distribution_epoch_id: 'Float',
    epoch_id: 'Float',
    id: 'Float',
    total_amount: 'Float',
    vault_id: 'Float',
  },
  distributions_stddev_samp_fields: {
    created_by: 'Float',
    distribution_epoch_id: 'Float',
    epoch_id: 'Float',
    id: 'Float',
    total_amount: 'Float',
    vault_id: 'Float',
  },
  distributions_sum_fields: {
    created_by: 'bigint',
    distribution_epoch_id: 'bigint',
    epoch_id: 'bigint',
    id: 'bigint',
    total_amount: 'numeric',
    vault_id: 'bigint',
  },
  distributions_var_pop_fields: {
    created_by: 'Float',
    distribution_epoch_id: 'Float',
    epoch_id: 'Float',
    id: 'Float',
    total_amount: 'Float',
    vault_id: 'Float',
  },
  distributions_var_samp_fields: {
    created_by: 'Float',
    distribution_epoch_id: 'Float',
    epoch_id: 'Float',
    id: 'Float',
    total_amount: 'Float',
    vault_id: 'Float',
  },
  distributions_variance_fields: {
    created_by: 'Float',
    distribution_epoch_id: 'Float',
    epoch_id: 'Float',
    id: 'Float',
    total_amount: 'Float',
    vault_id: 'Float',
  },
  epochs: {
    burns: 'burns',
    circle: 'circles',
    circle_id: 'Int',
    created_at: 'timestamp',
    days: 'Int',
    distributions: 'distributions',
    distributions_aggregate: 'distributions_aggregate',
    end_date: 'timestamptz',
    ended: 'Boolean',
    epoch_pending_token_gifts: 'pending_token_gifts',
    grant: 'numeric',
    id: 'bigint',
    notified_before_end: 'timestamp',
    notified_end: 'timestamp',
    notified_start: 'timestamp',
    number: 'Int',
    repeat: 'Int',
    repeat_day_of_month: 'Int',
    start_date: 'timestamptz',
    token_gifts: 'token_gifts',
    token_gifts_aggregate: 'token_gifts_aggregate',
    updated_at: 'timestamp',
  },
  gift_private: {
    gift_id: 'bigint',
    note: 'String',
    recipient: 'users',
    recipient_id: 'bigint',
    sender: 'users',
    sender_id: 'bigint',
  },
  mutation_root: {
    adminUpdateUser: 'UserResponse',
    allocationCsv: 'AllocationCsvResponse',
    createCircle: 'CreateCircleResponse',
    createEpoch: 'EpochResponse',
    createNominee: 'CreateNomineeResponse',
    createUser: 'UserResponse',
    createUsers: 'UserResponse',
    createVault: 'VaultResponse',
    deleteEpoch: 'DeleteEpochResponse',
    deleteUser: 'ConfirmationResponse',
    delete_circle_api_keys: 'circle_api_keys_mutation_response',
    delete_circle_api_keys_by_pk: 'circle_api_keys',
    delete_circle_integrations: 'circle_integrations_mutation_response',
    delete_circle_integrations_by_pk: 'circle_integrations',
    insert_circle_integrations: 'circle_integrations_mutation_response',
    insert_circle_integrations_one: 'circle_integrations',
    insert_claims: 'claims_mutation_response',
    insert_claims_one: 'claims',
    insert_distributions: 'distributions_mutation_response',
    insert_distributions_one: 'distributions',
    insert_vault_transactions: 'vault_transactions_mutation_response',
    insert_vault_transactions_one: 'vault_transactions',
    logoutUser: 'LogoutResponse',
    updateAllocations: 'AllocationsResponse',
    updateCircle: 'UpdateCircleOutput',
    updateEpoch: 'EpochResponse',
    updateTeammates: 'UpdateTeammatesResponse',
    updateUser: 'UserResponse',
    update_circles: 'circles_mutation_response',
    update_circles_by_pk: 'circles',
    update_claims: 'claims_mutation_response',
    update_claims_by_pk: 'claims',
    update_distributions: 'distributions_mutation_response',
    update_distributions_by_pk: 'distributions',
    update_profiles: 'profiles_mutation_response',
    update_profiles_by_pk: 'profiles',
    uploadCircleLogo: 'UpdateCircleResponse',
    uploadOrgLogo: 'UpdateOrgResponse',
    uploadProfileAvatar: 'UpdateProfileResponse',
    uploadProfileBackground: 'UpdateProfileResponse',
    vouch: 'VouchOutput',
  },
  nominees: {
    address: 'String',
    circle: 'circles',
    circle_id: 'Int',
    created_at: 'timestamp',
    description: 'String',
    ended: 'Boolean',
    expiry_date: 'timestamp',
    id: 'bigint',
    name: 'String',
    nominated_by_user_id: 'Int',
    nominated_date: 'date',
    nominations: 'vouches',
    nominator: 'users',
    updated_at: 'timestamp',
    user: 'users',
    user_id: 'Int',
    vouches_required: 'Int',
  },
  nominees_aggregate: {
    aggregate: 'nominees_aggregate_fields',
    nodes: 'nominees',
  },
  nominees_aggregate_fields: {
    avg: 'nominees_avg_fields',
    count: 'Int',
    max: 'nominees_max_fields',
    min: 'nominees_min_fields',
    stddev: 'nominees_stddev_fields',
    stddev_pop: 'nominees_stddev_pop_fields',
    stddev_samp: 'nominees_stddev_samp_fields',
    sum: 'nominees_sum_fields',
    var_pop: 'nominees_var_pop_fields',
    var_samp: 'nominees_var_samp_fields',
    variance: 'nominees_variance_fields',
  },
  nominees_avg_fields: {
    circle_id: 'Float',
    id: 'Float',
    nominated_by_user_id: 'Float',
    user_id: 'Float',
    vouches_required: 'Float',
  },
  nominees_max_fields: {
    address: 'String',
    circle_id: 'Int',
    created_at: 'timestamp',
    description: 'String',
    expiry_date: 'timestamp',
    id: 'bigint',
    name: 'String',
    nominated_by_user_id: 'Int',
    nominated_date: 'date',
    updated_at: 'timestamp',
    user_id: 'Int',
    vouches_required: 'Int',
  },
  nominees_min_fields: {
    address: 'String',
    circle_id: 'Int',
    created_at: 'timestamp',
    description: 'String',
    expiry_date: 'timestamp',
    id: 'bigint',
    name: 'String',
    nominated_by_user_id: 'Int',
    nominated_date: 'date',
    updated_at: 'timestamp',
    user_id: 'Int',
    vouches_required: 'Int',
  },
  nominees_stddev_fields: {
    circle_id: 'Float',
    id: 'Float',
    nominated_by_user_id: 'Float',
    user_id: 'Float',
    vouches_required: 'Float',
  },
  nominees_stddev_pop_fields: {
    circle_id: 'Float',
    id: 'Float',
    nominated_by_user_id: 'Float',
    user_id: 'Float',
    vouches_required: 'Float',
  },
  nominees_stddev_samp_fields: {
    circle_id: 'Float',
    id: 'Float',
    nominated_by_user_id: 'Float',
    user_id: 'Float',
    vouches_required: 'Float',
  },
  nominees_sum_fields: {
    circle_id: 'Int',
    id: 'bigint',
    nominated_by_user_id: 'Int',
    user_id: 'Int',
    vouches_required: 'Int',
  },
  nominees_var_pop_fields: {
    circle_id: 'Float',
    id: 'Float',
    nominated_by_user_id: 'Float',
    user_id: 'Float',
    vouches_required: 'Float',
  },
  nominees_var_samp_fields: {
    circle_id: 'Float',
    id: 'Float',
    nominated_by_user_id: 'Float',
    user_id: 'Float',
    vouches_required: 'Float',
  },
  nominees_variance_fields: {
    circle_id: 'Float',
    id: 'Float',
    nominated_by_user_id: 'Float',
    user_id: 'Float',
    vouches_required: 'Float',
  },
  organizations: {
    circles: 'circles',
    created_at: 'timestamp',
    id: 'bigint',
    logo: 'String',
    name: 'String',
    updated_at: 'timestamp',
    vaults: 'vaults',
  },
  pending_gift_private: {
    gift_id: 'bigint',
    note: 'String',
    recipient: 'users',
    recipient_id: 'bigint',
    sender: 'users',
    sender_id: 'bigint',
  },
  pending_token_gifts: {
    circle: 'circles',
    circle_id: 'bigint',
    created_at: 'timestamp',
    dts_created: 'timestamp',
    epoch: 'epochs',
    epoch_id: 'Int',
    gift_private: 'pending_gift_private',
    id: 'bigint',
    recipient: 'users',
    recipient_address: 'String',
    recipient_id: 'bigint',
    sender: 'users',
    sender_address: 'String',
    sender_id: 'bigint',
    tokens: 'Int',
    updated_at: 'timestamp',
  },
  profiles: {
    address: 'String',
    avatar: 'String',
    background: 'String',
    bio: 'String',
    created_at: 'timestamp',
    discord_username: 'String',
    github_username: 'String',
    id: 'bigint',
    medium_username: 'String',
    skills: 'String',
    telegram_username: 'String',
    twitter_username: 'String',
    updated_at: 'timestamp',
    users: 'users',
    website: 'String',
  },
  profiles_mutation_response: {
    affected_rows: 'Int',
    returning: 'profiles',
  },
  query_root: {
    burns: 'burns',
    burns_by_pk: 'burns',
    circle_api_keys: 'circle_api_keys',
    circle_api_keys_by_pk: 'circle_api_keys',
    circle_integrations: 'circle_integrations',
    circle_integrations_by_pk: 'circle_integrations',
    circle_private: 'circle_private',
    circles: 'circles',
    circles_by_pk: 'circles',
    claims: 'claims',
    claims_by_pk: 'claims',
    distributions: 'distributions',
    distributions_aggregate: 'distributions_aggregate',
    distributions_by_pk: 'distributions',
    epochs: 'epochs',
    epochs_by_pk: 'epochs',
    gift_private: 'gift_private',
    nominees: 'nominees',
    nominees_aggregate: 'nominees_aggregate',
    nominees_by_pk: 'nominees',
    organizations: 'organizations',
    organizations_by_pk: 'organizations',
    pending_gift_private: 'pending_gift_private',
    pending_token_gifts: 'pending_token_gifts',
    pending_token_gifts_by_pk: 'pending_token_gifts',
    profiles: 'profiles',
    profiles_by_pk: 'profiles',
    teammates: 'teammates',
    teammates_by_pk: 'teammates',
    token_gifts: 'token_gifts',
    token_gifts_aggregate: 'token_gifts_aggregate',
    token_gifts_by_pk: 'token_gifts',
    user_private: 'user_private',
    users: 'users',
    users_by_pk: 'users',
    vault_transactions: 'vault_transactions',
    vault_transactions_by_pk: 'vault_transactions',
    vaults: 'vaults',
    vaults_by_pk: 'vaults',
    vouches: 'vouches',
    vouches_by_pk: 'vouches',
  },
  subscription_root: {
    burns: 'burns',
    burns_by_pk: 'burns',
    circle_api_keys: 'circle_api_keys',
    circle_api_keys_by_pk: 'circle_api_keys',
    circle_integrations: 'circle_integrations',
    circle_integrations_by_pk: 'circle_integrations',
    circle_private: 'circle_private',
    circles: 'circles',
    circles_by_pk: 'circles',
    claims: 'claims',
    claims_by_pk: 'claims',
    distributions: 'distributions',
    distributions_aggregate: 'distributions_aggregate',
    distributions_by_pk: 'distributions',
    epochs: 'epochs',
    epochs_by_pk: 'epochs',
    gift_private: 'gift_private',
    nominees: 'nominees',
    nominees_aggregate: 'nominees_aggregate',
    nominees_by_pk: 'nominees',
    organizations: 'organizations',
    organizations_by_pk: 'organizations',
    pending_gift_private: 'pending_gift_private',
    pending_token_gifts: 'pending_token_gifts',
    pending_token_gifts_by_pk: 'pending_token_gifts',
    profiles: 'profiles',
    profiles_by_pk: 'profiles',
    teammates: 'teammates',
    teammates_by_pk: 'teammates',
    token_gifts: 'token_gifts',
    token_gifts_aggregate: 'token_gifts_aggregate',
    token_gifts_by_pk: 'token_gifts',
    user_private: 'user_private',
    users: 'users',
    users_by_pk: 'users',
    vault_transactions: 'vault_transactions',
    vault_transactions_by_pk: 'vault_transactions',
    vaults: 'vaults',
    vaults_by_pk: 'vaults',
    vouches: 'vouches',
    vouches_by_pk: 'vouches',
  },
  teammates: {
    created_at: 'timestamp',
    id: 'bigint',
    team_mate_id: 'Int',
    teammate: 'users',
    updated_at: 'timestamp',
    user: 'users',
    user_id: 'Int',
  },
  token_gifts: {
    circle: 'circles',
    circle_id: 'bigint',
    created_at: 'timestamp',
    dts_created: 'timestamp',
    epoch_id: 'Int',
    gift_private: 'gift_private',
    id: 'bigint',
    recipient: 'users',
    recipient_address: 'String',
    recipient_id: 'bigint',
    sender: 'users',
    sender_address: 'String',
    sender_id: 'bigint',
    tokens: 'Int',
    updated_at: 'timestamp',
  },
  token_gifts_aggregate: {
    aggregate: 'token_gifts_aggregate_fields',
    nodes: 'token_gifts',
  },
  token_gifts_aggregate_fields: {
    avg: 'token_gifts_avg_fields',
    count: 'Int',
    max: 'token_gifts_max_fields',
    min: 'token_gifts_min_fields',
    stddev: 'token_gifts_stddev_fields',
    stddev_pop: 'token_gifts_stddev_pop_fields',
    stddev_samp: 'token_gifts_stddev_samp_fields',
    sum: 'token_gifts_sum_fields',
    var_pop: 'token_gifts_var_pop_fields',
    var_samp: 'token_gifts_var_samp_fields',
    variance: 'token_gifts_variance_fields',
  },
  token_gifts_avg_fields: {
    circle_id: 'Float',
    epoch_id: 'Float',
    id: 'Float',
    recipient_id: 'Float',
    sender_id: 'Float',
    tokens: 'Float',
  },
  token_gifts_max_fields: {
    circle_id: 'bigint',
    created_at: 'timestamp',
    dts_created: 'timestamp',
    epoch_id: 'Int',
    id: 'bigint',
    recipient_address: 'String',
    recipient_id: 'bigint',
    sender_address: 'String',
    sender_id: 'bigint',
    tokens: 'Int',
    updated_at: 'timestamp',
  },
  token_gifts_min_fields: {
    circle_id: 'bigint',
    created_at: 'timestamp',
    dts_created: 'timestamp',
    epoch_id: 'Int',
    id: 'bigint',
    recipient_address: 'String',
    recipient_id: 'bigint',
    sender_address: 'String',
    sender_id: 'bigint',
    tokens: 'Int',
    updated_at: 'timestamp',
  },
  token_gifts_stddev_fields: {
    circle_id: 'Float',
    epoch_id: 'Float',
    id: 'Float',
    recipient_id: 'Float',
    sender_id: 'Float',
    tokens: 'Float',
  },
  token_gifts_stddev_pop_fields: {
    circle_id: 'Float',
    epoch_id: 'Float',
    id: 'Float',
    recipient_id: 'Float',
    sender_id: 'Float',
    tokens: 'Float',
  },
  token_gifts_stddev_samp_fields: {
    circle_id: 'Float',
    epoch_id: 'Float',
    id: 'Float',
    recipient_id: 'Float',
    sender_id: 'Float',
    tokens: 'Float',
  },
  token_gifts_sum_fields: {
    circle_id: 'bigint',
    epoch_id: 'Int',
    id: 'bigint',
    recipient_id: 'bigint',
    sender_id: 'bigint',
    tokens: 'Int',
  },
  token_gifts_var_pop_fields: {
    circle_id: 'Float',
    epoch_id: 'Float',
    id: 'Float',
    recipient_id: 'Float',
    sender_id: 'Float',
    tokens: 'Float',
  },
  token_gifts_var_samp_fields: {
    circle_id: 'Float',
    epoch_id: 'Float',
    id: 'Float',
    recipient_id: 'Float',
    sender_id: 'Float',
    tokens: 'Float',
  },
  token_gifts_variance_fields: {
    circle_id: 'Float',
    epoch_id: 'Float',
    id: 'Float',
    recipient_id: 'Float',
    sender_id: 'Float',
    tokens: 'Float',
  },
  user_private: {
    circle: 'circles',
    fixed_payment_amount: 'numeric',
    fixed_payment_token_type: 'String',
    user: 'users',
    user_id: 'bigint',
  },
  users: {
    address: 'String',
    bio: 'String',
    burns: 'burns',
    circle: 'circles',
    circle_id: 'bigint',
    created_at: 'timestamp',
    deleted_at: 'timestamp',
    epoch_first_visit: 'Boolean',
    fixed_non_receiver: 'Boolean',
    give_token_received: 'Int',
    give_token_remaining: 'Int',
    id: 'bigint',
    name: 'String',
    non_giver: 'Boolean',
    non_receiver: 'Boolean',
    pending_received_gifts: 'pending_token_gifts',
    pending_sent_gifts: 'pending_token_gifts',
    profile: 'profiles',
    received_gifts: 'token_gifts',
    received_gifts_aggregate: 'token_gifts_aggregate',
    role: 'Int',
    sent_gifts: 'token_gifts',
    sent_gifts_aggregate: 'token_gifts_aggregate',
    starting_tokens: 'Int',
    teammates: 'teammates',
    updated_at: 'timestamp',
    user_private: 'user_private',
  },
  vault_transactions: {
    created_at: 'timestamp',
    created_by: 'bigint',
    date: 'date',
    description: 'String',
    id: 'bigint',
    name: 'String',
    tx_hash: 'String',
    updated_at: 'timestamp',
    user: 'users',
    value: 'bigint',
    vault: 'vaults',
    vault_id: 'bigint',
  },
  vault_transactions_mutation_response: {
    affected_rows: 'Int',
    returning: 'vault_transactions',
  },
  vaults: {
    chain_id: 'Int',
    created_at: 'timestamptz',
    created_by: 'bigint',
    decimals: 'Int',
    id: 'bigint',
    org_id: 'bigint',
    profile: 'profiles',
    protocol: 'organizations',
    simple_token_address: 'String',
    symbol: 'String',
    token_address: 'String',
    updated_at: 'timestamptz',
    vault_address: 'String',
    vault_transactions: 'vault_transactions',
  },
  vouches: {
    created_at: 'timestamp',
    id: 'bigint',
    nominee: 'nominees',
    nominee_id: 'Int',
    updated_at: 'timestamp',
    voucher: 'users',
    voucher_id: 'Int',
  },
};

export const Ops = {
  mutation: 'mutation_root' as const,
  query: 'query_root' as const,
  subscription: 'subscription_root' as const,
};
